(function() {
  'use strict';

  angular
    .module('tnsp', [
      'ngAnimate',
      'ngCookies',
      'ngSanitize',
      'ngMessages',
      'ngAria',
      'ngResource',
      'ui.router',
      'ui.bootstrap',
      'toastr',
      'angular-ladda',
      'checklist-model',
      'bsLoadingOverlay',
      'angularMoment',
      'oitozero.ngSweetAlert',
      'mgo-angular-wizard',
      'ui.utils.masks',
      'angular-md5',
      'credit-cards'
    ]);

})();

(function () {
  'use strict';

  angular
  .module('tnsp')
  .controller('TicketsController', TicketsController);

  /** @ngInject */
  function TicketsController($rootScope, $q, $log, $scope, $window, $timeout, SweetAlert, rRoute, rSchedule, rRouteRate, rNationality, rBus, rClient, rTicket, rTrip, rBoarding, toastr, utilsService, WizardHandler, moment, authenticationService, bsLoadingOverlayService, GENRES, CIVIL_STATUS) {
    var vm = this,
      credentials = { userName: 'online.sales', password: 'ready2go' },
      now = moment(),
      minDate = new Date(),
      restartTicketsEvent,
      orderIdKey;

    var paymentIframe = document.createElement('iframe');

    vm.noTrips = false;
    vm.noSeats = false;
    var paymentTimer = null;
    vm.loading = false;

    vm.paymentMethods = [];

    vm.routesList = [];

    vm.busesTypes = [];
    vm.busesTypesT = [];

    vm.schedulesAvailable = [];
    vm.returnSchedulesAvailable = [];
    vm.schedulesAvailableT = [];
    vm.returnSchedulesAvailableT = [];

    vm.allSeats = [];
    vm.allReturnSeats = [];
    vm.allSeatsT = [];
    vm.allReturnSeatsT = [];

    vm.newticket = {};
    vm.newticket.typeOfTrip = 1;

    vm.selectedSeat = [];
    vm.selectedReturnSeat = [];
    vm.selectedSeatT = [];
    vm.selectedReturnSeatT = [];

    vm.newticket.clients = [];
    vm.selectedClient = {};

    vm.boardingList = [];
    vm.returnBoardingList = [];

    vm.finalTicketList = { tickets: [] };

    vm.dateConfig = { minDate: minDate };

    vm.ticketsPaid = false;
    vm.isPassengerFormOpen = false;

    vm.layoutClass = 'stretch';
    vm.wizardClass = 'transparency';

    vm.restartTickets = restartTickets;

    vm.years = [
      { value: 19, desc: '2019' },
      { value: 20, desc: '2020' },
      { value: 21, desc: '2021' },
      { value: 22, desc: '2022' },
      { value: 23, desc: '2023' },
      { value: 24, desc: '2024' },
      { value: 25, desc: '2025' },
      { value: 26, desc: '2026' },
      { value: 27, desc: '2027' },
      { value: 28, desc: '2028' },
      { value: 29, desc: '2029' },
      { value: 30, desc: '2030' }];

    vm.months = ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12'];


    vm.paymentErrors = '';
    vm.paymentErrorsDetails = '';
    vm.invoiceNumber;
    vm.paymentInProgress = false;


    vm.loadSchedulesAvailable = loadSchedulesAvailable;
    vm.loadSchedulesAvailableT = loadSchedulesAvailableT;
    vm.loadReturnSchedulesAvailable = loadReturnSchedulesAvailable;
    vm.loadReturnSchedulesAvailableT = loadReturnSchedulesAvailableT;
    vm.generateSeats = generateSeats;
    vm.generateTSeats = generateTSeats;
    vm.generateReturnSeats = generateReturnSeats;
    vm.generateReturnTSeats = generateReturnTSeats;
    vm.openOriginDate = openOriginDate;
    vm.openReturnDate = openReturnDate;

    vm.goToItinerary = goToItinerary;
    vm.toggleSeatSelection = toggleSeatSelection;
    vm.toggleSeatSelectionT = toggleSeatSelectionT;
    vm.toggleReturnSeatSelection = toggleReturnSeatSelection;
    vm.toggleReturnSeatSelectionT = toggleReturnSeatSelectionT;

    /*Step 2*/
    vm.searchClient = searchClient;
    vm.addClientToTicket = addClientToTicket;
    vm.chooseSeats = chooseSeats;
    vm.showMigrationRegulations = showMigrationRegulations;
    vm.showTermsAndConditions = showTermsAndConditions;
    vm.editClient = editClient;
    vm.removeClient = removeClient;
    vm.goToSelectSeats = goToSelectSeats;

    vm.genres = GENRES;
    vm.civilStatues = CIVIL_STATUS;
    vm.isEditingPassenger = false;
    vm.openIECalendar = openIECalendar;
    vm.openBDCalendar = openBDCalendar;
    vm.closePassengerForm = closePassengerForm;
    vm.submitClient = submitClient;
    vm.addNewClient = addNewClient;
    vm.submitPassenger = submitPassenger;
    vm.showR = false;

    vm.reserveTickets = reserveTickets;
    vm.refreshSeats = refreshSeats;
    vm.changeTypeOfTrip = changeTypeOfTrip;

    vm.calcTotalAndNext = calcTotalAndNext;

    /*Step3*/

    vm.goToConfirmation = goToConfirmation;

    /*Step 4*/
    vm.payTickets = payTickets;

    vm.restartTickets = restartTickets;
    vm.cancelReservation = cancelReservation;

    /*vm.openPaymentWindow = openPaymentWindow;*/

    vm.paymentProcess = paymentProcess;

    vm.postPaymentProcess = postPaymentProcess;


    init();

    /*Step 1*/

    function loadRoutes() {
      rRoute.query({}, function (result) {
        vm.routesList = result.records;
      });
    }

    function loadBusClasses() {
      rBus.getBusClasses({}, function (result) {
        vm.busClasses = result.records;
      });
    }

    function findReturnRoute(routeName) {
      var reverseRouteName = routeName.split(' - ').reverse().join(' - ');
      for (var i = 0; i < vm.routesList.length; i++) {
        if (vm.routesList[i].name.toLowerCase() === reverseRouteName) {
          return vm.routesList[i];
        }
      }
    }

    function loadSchedulesAvailable() {
      vm.noTrips = false;
      vm.noSeats = false;
      if (vm.newticket.typeOfTrip === '2') {
        var selectedRoute = vm.newTicket.route.name.toLowerCase();
        if (selectedRoute.indexOf('directo') <= -1 && selectedRoute.indexOf('extra') <= -1 && selectedRoute.indexOf('chinandega') <= -1) {
          vm.newTicket.returnRoute = findReturnRoute(selectedRoute);
          vm.disableReturnRoute = true;
        } else {
          vm.disableReturnRoute = false;
        }
      }

      /*if (vm.newTicket.route.id && vm.newTicket.route.transfer){
       vm.newTicket.busType =   vm.busClasses[1].id; // 1 = Regular
       }*/

      if (vm.newTicket.route.id && vm.originDateUI && vm.newTicket.busType) {
        if (!vm.newTicket.route.transfer) {
          rTrip.query({
            routeid: vm.newTicket.route.id,
            busclassid: vm.newTicket.busType,
            date: moment(vm.originDateUI).format('YYYY-MM-DD'),
            inclusive: true
          }, function (result) {
            vm.schedulesAvailable = result.records.filter(function (item) {
              return item.schedule.visible === true && item.schedule.isDisplayable === true;
            });
            vm.noTrips = !vm.schedulesAvailable.length > 0;
          });
        } else {
          rTrip.query({
            routeid: vm.newTicket.route.subRoutes[0].id,
            busclassid: vm.newTicket.busType,
            date: moment(vm.originDateUI).format('YYYY-MM-DD'),
            inclusive: true
          }, function (result) {
            vm.schedulesAvailable = result.records.filter(function (item) {
              return item.schedule.visible === true && item.schedule.isDisplayable === true;
            });
          });
        }
      } else {
        vm.noTrips = false;
        vm.noSeats = false;
        vm.schedulesAvailable = [];
        if (vm.newticket.typeOfTrip == 3 && vm.newTicket.route.id && vm.newTicket.busType) {
          rRouteRate.query({ routeId: vm.newTicket.route.id }, function (result) {
            var rates = result.records;
            var found = false;
            angular.forEach(rates, function (rate) {
              if (rate.busClass.id == vm.newTicket.busType) {
                vm.openRouteRate = rate;
                found = true;
              }
            });
            if (!found) {
              toastr.error('No hay viajes en esa ruta con ese tipo de bus');
            }
          });
        }
      }
    }

    function loadSchedulesAvailableT() {
      if (vm.originDateTUI && vm.newTicket.busTypeT) {
        rTrip.query({
          routeid: vm.newTicket.route.subRoutes[1].id,
          busclassid: vm.newTicket.busTypeT,
          date: moment(vm.originDateTUI).format('YYYY-MM-DD'),
          inclusive: true
        }, function (result) {
          vm.schedulesAvailableT = result.records.filter(function (item) {
            return item.schedule.visible === true && item.schedule.isDisplayable === true;
          });
        });
      } else {
        vm.schedulesAvailableT = [];
        if (vm.newticket.typeOfTrip == 3 && vm.newTicket.route.transfer && vm.newTicket.busTypeT) {
          rRouteRate.query({ routeId: vm.newTicket.route.id }, function (result) {
            var rates = result.records;
            var found = false;
            angular.forEach(rates, function (rate) {
              if (rate.busClass.id == vm.newTicket.busTypeT) {
                vm.openRouteRateT = rate;
                found = true;
              }
            });
            if (!found) {
              toastr.error('No hay viajes en esa ruta con ese tipo de bus');
            }
          });
        }
      }
    }

    function loadReturnSchedulesAvailable() {
      if (vm.newTicket.returnRoute && vm.returnDateUI && vm.newTicket.returnBusType) {
        vm.newTicket.selectedTrip = null;
        if (!vm.newTicket.returnRoute.transfer) {
          rTrip.query({
            routeid: vm.newTicket.returnRoute.id,
            busclassid: vm.newTicket.returnBusType,
            date: moment(vm.returnDateUI).format('YYYY-MM-DD'),
            inclusive: true
          }, function (result) {
            vm.returnSchedulesAvailable = result.records.filter(function (item) {
              return item.schedule.visible === true && item.schedule.isDisplayable === true;
            });

          });
        } else {
          rTrip.query({
            routeid: vm.newTicket.returnRoute.subRoutes[0].id,
            busclassid: vm.newTicket.returnBusType,
            date: moment(vm.returnDateUI).format('YYYY-MM-DD'),
            inclusive: true
          }, function (result) {
            vm.returnSchedulesAvailable = result.records.filter(function (item) {
              return item.schedule.visible === true && item.schedule.isDisplayable === true;
            });
          });
        }
      } else {
        vm.returnSchedulesAvailable = [];
      }
    }

    function loadReturnSchedulesAvailableT() {
      if (vm.returnDateTUI && vm.newTicket.returnBusTypeT) {
        rTrip.query({
          routeid: vm.newTicket.returnRoute.subRoutes[1].id,
          busclassid: vm.newTicket.returnBusTypeT,
          date: moment(vm.returnDateTUI).format('YYYY-MM-DD'),
          inclusive: true
        }, function (result) {
          vm.returnSchedulesAvailableT = result.records.filter(function (item) {
            return item.schedule.visible === true && item.schedule.isDisplayable === true;
          });
        });
      } else {
        vm.returnSchedulesAvailableT = [];
        if (vm.newticket.typeOfTrip == 3 && vm.newTicket.returnRoute.transfer && vm.newTicket.returnBusTypeT) {
          rRouteRate.query({ routeId: vm.newTicket.returnRoute.id }, function (result) {
            var rates = result.records;
            var found = false;
            angular.forEach(rates, function (rate) {
              if (rate.busClass.id == vm.newTicket.returnBusTypeT) {
                vm.openRouteRateT = rate;
                found = true;
              }
            });
            if (!found) {
              toastr.error('No hay viajes en esa ruta con ese tipo de bus');
            }
          });
        }
      }
    }

    function changeTypeOfTrip(_type) {
      vm.openRouteRate = null;
      if (_type === 3) {
        resetOriginTrip();
        resetReturnTrip();
      }
    }

    function generateSeats() {
        $timeout(function () {
          if (vm.newTicket.selectedTrip) {
            if (vm.newTicket.route.transfer) {
              rRouteRate.query({ routeId: vm.newTicket.route.id }, function (result) {
                vm.newTicket.priceWithTransfer = result.records[0].countryRates.CR;
                vm.newTicket.routeRateOfTransfer = result.records[0].id;
              })
            }
            for (var i = 1; i <= vm.newTicket.selectedTrip.seats; i++) {
              vm.allSeats.push({ seatNumber: i, isOccupied: false });
            }
            checkOccupiedSeats();
            vm.noSeats = !vm.allSeats.length > 0;
          } else {
            vm.allSeats = [];
          }
  
        }, 1000);
    }

    function generateTSeats() {
      $timeout(function () {
        if (vm.newTicket.selectedTripT) {
          for (var i = 1; i <= vm.newTicket.selectedTripT.seats; i++) {
            vm.allSeatsT.push({ seatNumber: i, isOccupied: false });
          }
          checkOccupiedSeatsT();
        } else {
          vm.allSeatsT = [];
        }
      }, 1000);
    }

    function generateReturnSeats() {
      $timeout(function () {
        if (vm.newTicket.selectedReturnTrip) {

          if (vm.newTicket.returnRoute.transfer) {
            rRouteRate.query({ routeId: vm.newTicket.returnRoute.id }, function (result) {
              vm.newTicket.returnPriceWithTransfer = result.records[0].countryRates.CR;

              vm.newTicket.returnRouteRateOfTransfer = result.records[0].id
            })
          }

          for (var i = 1; i <= vm.newTicket.selectedReturnTrip.seats; i++) {
            vm.allReturnSeats.push({ seatNumber: i, isOccupied: false });
          }

          checkReturnOccupiedSeats();
        } else {
          vm.allSeats = [];
        }
      }, 1000);
    }

    function generateReturnTSeats() {
      $timeout(function () {
        if (vm.newTicket.selectedReturnTripT) {
          for (var i = 1; i <= vm.newTicket.selectedReturnTripT.seats; i++) {
            vm.allReturnSeatsT.push({ seatNumber: i, isOccupied: false });
          }
          checkReturnOccupiedSeatsT();
        } else {
          vm.allSeatsT = [];
        }
      }, 1000);
    }

    function checkOccupiedSeats() {
      vm.newTicket.selectedTrip.availableSeats = (vm.newTicket.selectedTrip.seats - vm.newTicket.selectedTrip.tripSeats.length);

      angular.forEach(vm.newTicket.selectedTrip.seats, function (occupiedSeat) {
        angular.forEach(vm.allSeats, function (availableSeat) {
          if (occupiedSeat.seatNumber === availableSeat.seatNumber) {
            availableSeat.isOccupied = true;
            availableSeat.selected = false;
            vm.newTicket.selectedTrip.availableSeats--;
          }
        })
      });
    }

    function checkOccupiedSeatsT() {
      if (!vm.newTicket.selectedTripT.tripSeats) {vm.newTicket.selectedTripT.tripSeats = []}
      vm.newTicket.selectedTripT.availableSeats = (vm.newTicket.selectedTripT.seats - vm.newTicket.selectedTripT.tripSeats.length);

      angular.forEach(vm.newTicket.selectedTripT.seats, function (occupiedSeat) {
        angular.forEach(vm.allSeatsT, function (availableSeat) {
          if (occupiedSeat.seatNumber === availableSeat.seatNumber) {
            availableSeat.isOccupied = true;
            availableSeat.selected = false;
            vm.newTicket.selectedTrip.availableSeats--;
          }
        })
      });
    }

    /*function checkReturnOccupiedSeats() {
     vm.newTicket.selectedReturnTrip.availableSeats = (vm.newTicket.selectedReturnTrip.seats - vm.newTicket.selectedReturnTrip.tripSeats.length);

     angular.forEach(vm.newTicket.selectedReturnTrip.seats, function (occupiedSeat) {
     angular.forEach(vm.allReturnSeats, function (availableSeat) {
     if (occupiedSeat.seatNumber === availableSeat.seatNumber) {
     availableSeat.isOccupied = true;
     availableSeat.selected = false;
     vm.newTicket.selectedReturnTrip.availableSeats--;
     }
     })
     });
     }*/

    function checkReturnOccupiedSeatsT() {
      vm.newTicket.selectedReturnTripT.availableSeats = (vm.newTicket.selectedReturnTripT.seats - vm.newTicket.selectedReturnTripT.tripSeats.length);

      angular.forEach(vm.newTicket.selectedReturnTripT.seats, function (occupiedSeat) {
        angular.forEach(vm.allReturnSeatsT, function (availableSeat) {
          if (occupiedSeat.seatNumber === availableSeat.seatNumber) {
            availableSeat.isOccupied = true;
            availableSeat.selected = false;
            vm.newTicket.selectedReturnTripT.availableSeats--;
          }
        })
      });
    }

    function checkReturnOccupiedSeats() {
      vm.newTicket.selectedReturnTrip.availableSeats = (vm.newTicket.selectedReturnTrip.seats - vm.newTicket.selectedReturnTrip.tripSeats.length);

      angular.forEach(vm.newTicket.selectedReturnTrip.seats, function (occupiedSeat) {
        angular.forEach(vm.allReturnSeats, function (availableSeat) {
          if (occupiedSeat.seatNumber === availableSeat.seatNumber) {
            availableSeat.isOccupied = true;
            availableSeat.selected = false;
            vm.newTicket.selectedReturnTrip.availableSeats--;
          }
        })
      });
    }

    function loadReturnSchedulesAvailable() {
      if (vm.newTicket.returnRoute && vm.returnDateUI && vm.newTicket.returnBusType) {
        if (!vm.newTicket.returnRoute.transfer) {
          rTrip.query({
            routeid: vm.newTicket.returnRoute.id,
            busclassid: vm.newTicket.returnBusType,
            date: moment(vm.returnDateUI).format('YYYY-MM-DD'),
            inclusive: true
          }, function (result) {
            vm.returnSchedulesAvailable = result.records.filter(function (item) {
              return item.schedule.visible === true && item.schedule.isDisplayable === true;
            });
          });
        } else {
          rTrip.query({
            routeid: vm.newTicket.returnRoute.subRoutes[0].id,
            busclassid: vm.newTicket.returnBusType,
            date: moment(vm.returnDateUI).format('YYYY-MM-DD'),
            inclusive: true
          }, function (result) {
            vm.returnSchedulesAvailable = result.records.filter(function (item) {
              return item.schedule.visible === true && item.schedule.isDisplayable === true;
            });
          });
        }
      } else {
        vm.returnSchedulesAvailable = [];
      }
    }

    function loadReturnSchedulesAvailableT() {
      if (vm.returnDateTUI && vm.newTicket.returnBusTypeT) {
        rTrip.query({
          routeid: vm.newTicket.returnRoute.subRoutes[1].id,
          busclassid: vm.newTicket.returnBusTypeT,
          date: moment(vm.returnDateTUI).format('YYYY-MM-DD'),
          inclusive: true
        }, function (result) {
          vm.returnSchedulesAvailableT = result.records.filter(function (item) {
            return item.schedule.visible === true && item.schedule.isDisplayable === true;
          });
        });
      } else {
        vm.returnSchedulesAvailableT = [];
        if (vm.newticket.typeOfTrip == 3 && vm.newTicket.returnRoute.transfer && vm.newTicket.returnBusTypeT) {
          rRouteRate.query({ routeId: vm.newTicket.returnRoute.id }, function (result) {
            var rates = result.records;
            var found = false;
            angular.forEach(rates, function (rate) {
              if (rate.busClass.id == vm.newTicket.returnBusTypeT) {
                vm.openRouteRateT = rate;
                found = true;
              }
            });
            if (!found) {
              toastr.error('No hay viajes en esa ruta con ese tipo de bus');
            }
          });
        }
      }
    }

    function openOriginDate() {
      vm.showOriginCalendar = true;
    }

    function openReturnDate() {
      vm.showReturnCalendar = true;
    }

    function changeLayout(goToSearch) {
      if (WizardHandler.wizard('ticket-wizard').currentStepNumber() === 0 || goToSearch) {
        $timeout(function () {
          vm.newticket = {};
          vm.newticket.clients = [];
          vm.layoutClass = "stretch";
          vm.wizardClass = "transparency";
          $('.tickets .wizard .steps-indicator').hide();
        }, 100);

      } else {
        vm.layoutClass = "";
        vm.wizardClass = "white-bg";
        $('.tickets .wizard .steps-indicator').show();
      }
    }

    function goToItinerary(form) {
      vm.submitAttemptStep1 = true;
      if (!form.$valid) {
        return
      }

      if (vm.newticket.typeOfTrip != 3){
        loadNationalities();
        loadBoardings(vm.newTicket.route, vm.newTicket.selectedTrip.schedule);

        if (vm.newTicket.returnRoute) {
          loadReturnBoardings(vm.newTicket.returnRoute, vm.newTicket.selectedReturnTrip.schedule);
        } 
      }
      
      WizardHandler.wizard('ticket-wizard').next();
      changeLayout();
    }

    /*---*/

    /*Step 2*/

    function goToSelectSeats(form) {

      vm.submitAttemptStep2 = true;
      if (!form.$valid || !vm.newticket.clients.length > 0) {
        return
      }

      if (vm.newticket.typeOfTrip != 3) {
        refreshSeats();
        if (vm.newTicket.selectedReturnTrip) {
          refreshReturnSeats();
        }
        WizardHandler.wizard('ticket-wizard').next();
      } else {
        calcOpenTickets();
        WizardHandler.wizard('ticket-wizard').next();
      }
    }

    function calcOpenTickets() {
      vm.newTicket.total = (vm.openRouteRate.countryRates.CR * vm.newticket.clients.length);
    }

    function loadBoardings(route, schedule) {
      var routeId;
      if (!route.transfer) {
        routeId = route.id;
      } else {
        routeId = route.subRoutes[0].id
      }

      rBoarding.query({ pagesize: 100, routeId: routeId }, function (result) {
        vm.boardingList = result.records;
        loadInvalidBoardings(schedule, routeId);
      });
    }

    function loadReturnBoardings(route, schedule) {

      var routeId;
      if (!route.transfer) {
        routeId = route.id;
      } else {
        routeId = route.subRoutes[0].id
      }


      rBoarding.query({ pagesize: 100, routeId: route.id }, function (result) {
        vm.returnBoardingList = result.records
      });

      loadReturnInvalidBoardings(schedule, routeId);
    }

    function loadInvalidBoardings(schedule, routeId) {
      rSchedule.query({ id: schedule.id, routeId: routeId }, function (result) {
        var schedule = result;
        updateList(vm.boardingList, schedule.invalidBoardings);


        var tempBoardings = [];
        angular.forEach(vm.boardingList, function (boarding) {
          if (!boarding.hide) {
            tempBoardings.push(boarding);
          }
        });

        angular.copy(tempBoardings, vm.boardingList)

      });
    }

    function loadReturnInvalidBoardings(schedule, routeId) {

      rSchedule.query({ id: schedule.id, routeId: routeId }, function (result) {
        var returnSchedule = result;
        updateList(vm.returnBoardingList, returnSchedule.invalidBoardings);


        var tempReturnBoardings = [];
        angular.forEach(vm.returnBoardingList, function (boarding) {
          if (!boarding.hide) {
            tempReturnBoardings.push(boarding);
          }
        });

        angular.copy(tempReturnBoardings, vm.returnBoardingList);

      });
    }

    function updateList(list, list2) {
      angular.forEach(list, function (item, index) {
        angular.forEach(list2, function (item2) {
          if (item.id === item2.id) {
            item.hide = true;
          }
        });
      });

    }

    function searchClient(id) {
      if (id) {
        rClient.query({ identification: id }, function (result) {
          if (result.records.length > 0) {
            vm.searchedClient = result.records[0];
            addClientToTicket();
          } else {
            vm.searchedClient = {};
            toastr.error('No se encontró un cliente con esa identificación');
          }
        });
      } else {
        angular.copy({}, vm.searchedClient);
      }
    }

    function addClientToTicket() {
      if (!angular.equals({}, vm.searchedClient) && vm.searchedClient != undefined) {
        if (!utilsService.isObjectOnList(vm.searchedClient, vm.newticket.clients, 'identification')) {
          vm.searchedClient.boarding = vm.searchedClientBoarding;
          vm.searchedClient.boardingT = vm.searchedClientBoardingT;
          vm.searchedClient.returnBoarding = vm.searchedClientReturnBoarding;

          vm.newticket.clients.push(vm.searchedClient);

          if (moment(vm.searchedClient.identificationExpiration).subtract(6, 'months') < now) {
            toastr.warning('El Pasaporte está vencido o por vencer en menos de 6 meses', 'Vencimiento de Pasaporte');
          }
          vm.showRegulations = true;

          vm.searchedClient = {};
          vm.identificationToSearch = '';
          vm.searchedClientBoarding = '';
          vm.searchedClientReturnBoarding = '';

        } else {
          angular.copy({}, vm.searchedClient);
          toastr.info('No puede agregar el mismo cliente 2 veces');
        }
      } else {
        toastr.error('Debe buscar y seleccionar un cliente');
      }
    }

    function submitClient(form) {
      vm.submitPassengerAttempt = true;
      if (!form.$valid) {
        return;
      } else {
        vm.submitPassengerAttempt = false;
        vm.passenger.identificationType = { id: 2 };
        rClient.save(vm.passenger, function (response) {
          vm.isPassengerFormOpen = false;
          vm.searchedClient = response;
          delete vm.searchedClient.$promise;
          delete vm.searchedClient.$resolved;
          addClientToTicket();
          toastr.success('El Pasajero fue creado satisfactoriamente');
          $rootScope.$broadcast('clientCreated');
          vm.passenger = {};

        }, function (error) {
          toastr.error('Hubo un error al agregar al pasajero', error.data.message);
        });
      }
    }

    function addNewClient(form) {

      vm.passenger.identificationType = { id: 2 };
      vm.passenger.isNew = true;
      vm.passenger.fullName = vm.passenger.firstName + " " + vm.passenger.lastName;

      rClient.save(vm.passenger, function (response) {
        toastr.success('Cliente Creado satisfactoriamente');
        vm.newticket.clients.push(vm.passenger);
        vm.isPassengerFormOpen = false;
        vm.passenger = {};

        vm.submitPassengerAttempt = false;


        addNewClientToTicket(response);

      }, function (error) {
        toastr.error('Hubo un error al agregar al pasajero', error.data.message);

      });

    }

    function submitPassenger(form) {
      vm.submitPassengerAttempt = true;
      if (!form.$valid) {
        return;
      } else {
        if (vm.isEditingPassenger) {
          updateClient(clientForm);
        } else {
          addNewClient(clientForm);
        }
      }
    }

    function chooseSeats() {
      vm.seats = null;

      var allBordingSelected = true
      angular.forEach(vm.newticket.clients, function (client, index){
        if (!client.boarding){
          allBordingSelected = false;
        }
      });

      if (!allBordingSelected){
        toastr.error('Seleccione los abordajes');
        return;
      }

      angular
        .element('#modalSeatsForm')
        .modal({ backdrop: 'static', keyboard: false });
    }

    function updateClient(clientForm) {
      angular.forEach(vm.newticket.clients, function (client, index) {
        if (client.identification === vm.passenger.identification) {
          vm.passenger.fullName = vm.passenger.firstName + " " + vm.passenger.lastName;
          vm.newticket.clients[index] = vm.passenger;
          vm.isPassengerFormOpen = false;
          vm.isEditingPassenger = false;
          vm.passenger = {};
        }
      });
    }

    function editClient(client) {
      angular.copy(client, vm.passenger);
      vm.isPassengerFormOpen = true;
      vm.isEditingPassenger = true;
    }

    function removeClient(index) {
      vm.newticket.clients.splice(index, 1);
    }

    function calcTotalAndNext() {
      calcOpenTickets();
      WizardHandler.wizard('ticket-wizard').next();
    }

    /*Step 3*/

    function loadNationalities() {
      rNationality.query({}, function (result) {
        vm.nationalities = result;
      });
    }

    function openIECalendar() {
      vm.showIECalendar = true;
    }

    function openBDCalendar() {
      vm.showBDCalendar = true;
    }

    function closePassengerForm() {
      vm.isPassengerFormOpen = false;
      // TODO: clean form
    }

    function refreshSeats() {
      rTrip.getOccupiedSeats({ id: vm.newTicket.selectedTrip.id }, function (result) {
        var occupiedSeats = result;
        angular.forEach(occupiedSeats, function (occupiedSeat) {
          angular.forEach(vm.allSeats, function (availableSeat) {
            if (occupiedSeat.seatNumber === availableSeat.seatNumber) {
              availableSeat.isOccupied = true;
              availableSeat.selected = false;
              removeSeat(occupiedSeat);
            }
          })
        });

      });

      if (vm.newTicket.selectedTripT) {
        rTrip.getOccupiedSeats({ id: vm.newTicket.selectedTripT.id }, function (result) {
          var occupiedSeats = result;
          angular.forEach(occupiedSeats, function (occupiedSeat) {
            angular.forEach(vm.allSeatsT, function (availableSeat) {
              if (occupiedSeat.seatNumber === availableSeat.seatNumber) {
                availableSeat.isOccupied = true;
                availableSeat.selected = false;
                removeSeatT(occupiedSeat);
              }
            })
          });
        });
      }
    }

    function refreshReturnSeats() {
      rTrip.getOccupiedSeats({ id: vm.newTicket.selectedReturnTrip.id }, function (result) {
        var occupiedSeats = result;
        angular.forEach(occupiedSeats, function (occupiedSeat) {
          angular.forEach(vm.allReturnSeats, function (availableSeat) {
            if (occupiedSeat.seatNumber === availableSeat.seatNumber) {
              availableSeat.isOccupied = true;
              availableSeat.selected = false;
              removeReturnSeat(occupiedSeat);
            }
          })
        });

      })
    }

    function toggleSeatSelection(seat) {
      if (!seat.selected) {
        seat.selected = true;
        vm.selectedSeat.push(seat);
      } else {
        seat.selected = false;
        removeSeat(seat);
      }
    }

    function toggleSeatSelectionT(seat) {
      if (!seat.selected) {
        seat.selected = true;
        vm.selectedSeatT.push(seat);
      } else {
        seat.selected = false;
        removeSeatT(seat);
      }
    }

    function toggleReturnSeatSelection(seat) {
      if (!seat.selected) {
        seat.selected = true;
        vm.selectedReturnSeat.push(seat);
      } else {
        seat.selected = false;
        removeReturnSeat(seat);
      }
    }

    function toggleReturnSeatSelectionT(seat) {
      if (!seat.selected) {
        seat.selected = true;
        vm.selectedReturnSeatT.push(seat);
      } else {
        seat.selected = false;
        removeReturnTSeat(seat);
      }
    }

    function removeSeat(_seat) {
      var index = -1;
      angular.forEach(vm.selectedSeat, function (seat, _index) {
        if (seat.id === _seat.id) {
          index = _index;
        }
      });
      vm.selectedSeat.splice(index, 1);
    }

    function removeSeatT(_seat) {
      var index = -1;
      angular.forEach(vm.selectedSeatT, function (seat, _index) {
        if (seat.id === _seat.id) {
          index = _index;
        }
      });
      vm.selectedSeatT.splice(index, 1);
    }

    function removeReturnSeat(_seat) {
      var index = -1;
      angular.forEach(vm.selectedReturnSeat, function (seat, _index) {
        if (seat.id === _seat.id) {
          index = _index;
        }
      });
      vm.selectedReturnSeat.splice(index, 1);
    }

    function removeReturnTSeat(_seat) {
      var index = -1;
      angular.forEach(vm.selectedReturnSeatT, function (seat, _index) {
        if (seat.id === _seat.id) {
          index = _index;
        }
      });
      vm.selectedReturnSeatT.splice(index, 1);
    }

    function toggleReturnSeatSelection(seat) {
      if (!seat.selected) {
        seat.selected = true;
        vm.selectedReturnSeat.push(seat);
      } else {
        seat.selected = false;
        removeReturnSeat(seat);
      }
    }

    function getSeatsToReserve(twoWays) {
      var list = (!twoWays) ? vm.selectedSeat : vm.selectedReturnSeat;
      var seats = [];

      angular.forEach(vm.newticket.clients, function (client, index) {
        seats.push({ clientId: client.id, seatNumber: list[index].seatNumber });
      });

      return seats;
    }

    function getSeatsToReserveT(twoWays) {
      var list = (!twoWays) ? vm.selectedSeatT : vm.selectedReturnSeatT;
      var seats = [];

      angular.forEach(vm.newticket.clients, function (client, index) {
        seats.push({ clientId: client.id, seatNumber: list[index].seatNumber });
      });

      return seats;
    }

    function reserveTickets(twoWays) {
      if (twoWays) {
        reserveRoundTrip()
      } else {
        var seats = getSeatsToReserve();
        var tripId = vm.newTicket.selectedTrip.id;
        rTicket.reserve({ tripId: tripId, seats: seats }, function () {
          toastr.success('Reservación Satisfactoria');
          vm.newTicket.total = (vm.newTicket.selectedTrip.schedule.routeRate.countryRates.CR * vm.newticket.clients.length);

          /*TRANSFER*/

          if (vm.newTicket.route.transfer) {
            var seatsT = getSeatsToReserveT();
            var tripIdT = vm.newTicket.selectedTripT.id;

            rTicket.reserve({ tripId: tripIdT, seats: seatsT }, function () {

              vm.newTicket.total = (vm.newTicket.priceWithTransfer * vm.newticket.clients.length);

              toastr.success('Reservación Satisfactoria');
              WizardHandler.wizard('ticket-wizard').next();
            });

          } else {
            toastr.success('Reservación Satisfactoria');
            WizardHandler.wizard('ticket-wizard').next();
          }


          closeSeatsModal();
          WizardHandler.wizard('ticket-wizard').next();


          createPaymentIframe();

        }, function (error) {
          toastr.error(error.data.message, 'Error de reservación');
          refreshSeats();
        });
      }
    }

    function reserveRoundTrip() {
      var seats = getSeatsToReserve();
      var tripId = vm.newTicket.selectedTrip.id;

      /* First Way Reservation */
      rTicket.reserve({ tripId: tripId, seats: seats }, function () {


        /*TRANSFER*/
        if (vm.newTicket.route.transfer) {
          var seatsT = getSeatsToReserveT();
          var tripIdT = vm.newTicket.selectedTripT.id;

          rTicket.reserve({ tripId: tripIdT, seats: seatsT }, function () {});
        }

        /*RETURN RESERVATION STARTS HERE */
        var returnSeats = getSeatsToReserve(true);
        var returnTripId = vm.newTicket.selectedReturnTrip.id;

        rTicket.reserve({ tripId: returnTripId, seats: returnSeats }, function () {


          /*TRANSFER*/
          if (vm.newTicket.returnRoute.transfer) {
            var returnSeatsT = getSeatsToReserveT(true);
            var returnTripTId = vm.newTicket.selectedReturnTripT.id;
            rTicket.reserve({ tripId: returnTripTId, seats: returnSeatsT }, function () {});
          }

          vm.newTicket.total = 0;


          //First way amount;
          vm.newTicket.total +=
            (vm.newTicket.route.transfer) ?
              (vm.newTicket.priceWithTransfer * vm.newticket.clients.length) :
              (vm.newTicket.selectedTrip.schedule.routeRate.countryRates.CR * vm.newticket.clients.length);

          //Return way amount;
          vm.newTicket.total +=
            (vm.newTicket.returnRoute.transfer) ?
              (vm.newTicket.returnPriceWithTransfer * vm.newticket.clients.length) :
              (vm.newTicket.selectedReturnTrip.schedule.routeRate.countryRates.CR * vm.newticket.clients.length);

          toastr.success('Reservación Satisfactoria');


          closeSeatsModal();
          WizardHandler.wizard('ticket-wizard').next();

          createPaymentIframe();

        }, function (error) {
          toastr.error(error.data.message, 'Error de reservación');
          refreshSeats();
          refreshReturnSeats();
        });

      }, function (error) {
        toastr.error(error.data.message, 'Error de reservación');
        refreshSeats();
        refreshReturnSeats();

      });
    }

    function goToConfirmation(form) {
      vm.submitAttemptStep3 = true;
      if (!form.$valid ||
        (vm.selectedSeat.length !== vm.newticket.clients.length) ||
        (vm.newticket.typeOfTrip == 2 && vm.selectedReturnSeat.length !== vm.newticket.clients.length)) {
        return
      }
      saveNewClients();

      setPaymentTimer();

    }

    function saveNewClients() {
      vm.submitAttemptStep3 = false;
      if (vm.newticket.typeOfTrip == 2) {
        reserveTickets(true);
      } else {
        reserveTickets();
      }

    }

    function addNewClientToTicket(clientObj) {

      angular.forEach(vm.newticket.clients, function (client, index) {
        if (client.identification === clientObj.identification) {
          vm.newticket.clients[index] = clientObj;
          if (moment(client.identificationExpiration).subtract(6, 'months') < now) {
            vm.showRegulations = true;
            toastr.warning('El Pasaporte está vencido o por vencer en menos de 6 meses', 'Vencimiento de Pasaporte');
          }
        }
      });

    }

    function closeSeatsModal() {
      angular.element('#modalSeatsForm').modal('hide');
    }

    function showMigrationRegulations() {
      angular.element('#modalRegulations').modal({ backdrop: 'static', keyboard: false });
    }

    function showTermsAndConditions() {
      vm.seats = null;
      angular.element('#modalTermsAndConditions').modal({ backdrop: 'static', keyboard: false });
    }

    /*Step 4*/

    function setPaymentTimer() {
      paymentTimer = $timeout(function () {
        SweetAlert.warning({
            title: '',
            text: 'Tu Reservación ha expirado, debe iniciar nuevamente la compra',
            showCancelButton: false,
            confirmButtonText: 'Aceptar',
            closeOnConfirm: true,
            closeOnCancel: true,
            allowEscapeKey: false
          },
          function () {
            restartTickets();
          }
        );
      }, 420000); // timer of 7 min  ( 1000 * 60 * 7 )
    }

    function payTickets(form) {

      bsLoadingOverlayService.start({ referenceId: 'ticket-payment' });
      vm.loading = true;
      vm.paymentInProgress = true;
      vm.paymentErrors = '';
      vm.paymentErrorsDetails = '';
      vm.submitAttemptStep4 = true;
      if (!form.$valid) {
        bsLoadingOverlayService.stop({ referenceId: 'ticket-payment' });
        vm.paymentInProgress = false;
        vm.loading = false;
        return
      }

      paymentProcess();
    }

    function restartTickets() {
      $window.location.reload();
    }

    function cancelReservation() {

      $timeout.cancel(paymentTimer);

      paymentIframe.remove();
      window.removeEventListener('message', listenPaymentCallback);

      var clientIds = [];
      angular.forEach(vm.newticket.clients, function (client) {
        clientIds.push(client.id);
      });

      if (!vm.newTicket.selectedReturnTrip) {
        rTicket.cancelReserve({ tripId: vm.newTicket.selectedTrip.id, clientIds: clientIds }, function () {
          toastr.info('Reservación cancelada');
          $timeout(function () {
            $window.location.reload();
          }, 1500);
        });
      } else {
        rTicket.cancelReserve({ tripId: vm.newTicket.selectedTrip.id, clientIds: clientIds }, function () {
          rTicket.cancelReserve({ tripId: vm.newTicket.selectedTrip.id, clientIds: clientIds }, function () {
            toastr.info('Reservación cancelada');
            $timeout(function () {
              $window.location.reload();
            }, 1500);
          });

        });
      }
    }

    function createPaymentIframe() {
      var iframeSource = '/#/payment';

      paymentIframe.setAttribute('src', iframeSource);
      paymentIframe.setAttribute('id', 'PaymentIframe');
      paymentIframe.style.width = 0 + 'px';
      paymentIframe.style.height = 0 + 'px';
      document.body.appendChild(paymentIframe);

      // Listen Payment Redirect
      window.addEventListener('message', listenPaymentCallback, false);
    }

    function paymentProcess() {
      var payment = {};
      payment.tickets = [];
      payment.paymentTypes = [];


      angular.forEach(vm.newticket.clients, function (client, index) {
        var ticket = {};
        ticket.client = { id: client.id };
        ticket.hasDiscount = false;

        if (vm.newticket.typeOfTrip == 1) {
          ticket.tripSeat = {};
          ticket.tripSeat.trip = { id: vm.newTicket.selectedTrip.id };
          ticket.tripSeat.seatNumber = vm.selectedSeat[index].seatNumber;
          if (client.boarding) {
            ticket.boarding = {};
            ticket.boarding.id = client.boarding.id;
          }
          if (vm.newTicket.route.transfer) {
            ticket.isSubRoute = true;
            ticket.mainRoute = {};
            ticket.mainRoute = { id: vm.newTicket.routeRateOfTransfer };
          }

          payment.tickets.push(ticket);

          // Transfer
          if (vm.newTicket.route.transfer) {
            ticket = {};
            ticket.client = { id: client.id };
            ticket.hasDiscount = client.hasDiscount;
            ticket.tripSeat = {};
            ticket.tripSeat.trip = { id: vm.newTicket.selectedTripT.id };
            ticket.tripSeat.seatNumber = vm.selectedSeatT[index].seatNumber;
            if (client.boardingT) {
              ticket.boarding = {};
              ticket.boarding.id = client.boardingT.id;
            }
            ticket.isSubRoute = true;
            ticket.mainRoute = {};
            ticket.mainRoute = { id: vm.newTicket.routeRateOfTransfer };

            payment.tickets.push(ticket);
          }
        } else if (vm.newticket.typeOfTrip == 2) {
          angular.forEach(vm.newticket.clients, function (client, index) {
            var ticket = {};
            ticket.client = { id: client.id };

            ticket.tripSeat = {};
            ticket.tripSeat.trip = { id: vm.newTicket.selectedReturnTrip.id };
            ticket.tripSeat.seatNumber = vm.selectedReturnSeat[index].seatNumber;

            if (client.returnBoarding) {
              ticket.boarding = {};
              ticket.boarding.id = client.returnBoarding.id;
            }

            payment.tickets.push(ticket);
          });
        } else if (vm.newticket.typeOfTrip == 3) {
          if (client.boarding) {
            ticket.boarding = {};
            ticket.boarding.id = client.boarding.id;
          }
          ticket.routeRate = vm.openRouteRate;
          ticket.status = 'OPEN';

          payment.tickets.push(ticket);
        }

      });

      orderIdKey = Math.floor(new Date() / 1000);

      /*Payment*/
      var ticketData = {
        orderKey: orderIdKey,
        cardNumber: vm.creditCard.number,
        exp: ('' + vm.creditCard.expiration.month + vm.creditCard.expiration.year).toString(),
        cvv: vm.creditCard.cvv,
        total: vm.newTicket.total
      };

      var ticketDataStringify = JSON.stringify(ticketData);
       paymentIframe.contentWindow.postMessage(ticketDataStringify, '*');
    }

    function listenPaymentCallback(e) {
      var data;
      if (typeof e.data !== 'object') {
        data = JSON.parse(e.data);

        if (data.response_code !== '100') {
          vm.paymentErrors = 'Tarjeta Invalida';
          vm.paymentErrorsDetails = data.responsetext;
          vm.paymentInProgress = false;
          vm.loading = false;
        } else {
          vm.invoiceNumber = data.transactionid;
          postPaymentProcess(data.transactionid);
        }
      }

      bsLoadingOverlayService.stop({ referenceId: 'ticket-payment' });
    }

    function postPaymentProcess(transactionId) {


      var payment = {};
      payment.tickets = [];
      payment.paymentTypes = [];

      payment.paymentTypes.push({
        paymentType: 'Online',
        amount: vm.newTicket.total,
        cardConfirmation: transactionId
      });


      angular.forEach(vm.newticket.clients, function (client, index) {
        var ticket = {};
        ticket.client = { id: client.id };

        if (vm.newticket.typeOfTrip == 1) {
          ticket.tripSeat = {};
          ticket.tripSeat.trip = { id: vm.newTicket.selectedTrip.id };
          ticket.tripSeat.seatNumber = vm.selectedSeat[index].seatNumber;
          if (client.boarding) {
            ticket.boarding = {};
            ticket.boarding.id = client.boarding.id;
          }

          if (vm.newTicket.route.transfer) {
            ticket.isSubRoute = true;
            ticket.mainRoute = {};
            ticket.mainRoute = { id: vm.newTicket.routeRateOfTransfer };
          }

          payment.tickets.push(ticket);


          // Transfer
          if (vm.newTicket.route.transfer) {
            ticket = {};
            ticket.client = { id: client.id };
            ticket.tripSeat = {};
            ticket.tripSeat.trip = { id: vm.newTicket.selectedTripT.id };
            ticket.tripSeat.seatNumber = vm.selectedSeatT[index].seatNumber;
            if (client.boardingT) {
              ticket.boarding = {};
              ticket.boarding.id = client.boardingT.id;
            }
            ticket.isSubRoute = true;
            ticket.mainRoute = {};
            ticket.mainRoute = { id: vm.newTicket.routeRateOfTransfer };

            payment.tickets.push(ticket);
          }


        } else if (vm.newticket.typeOfTrip == 2) {
          // First way ticket
          ticket = {};
          ticket.client = { id: client.id };
          ticket.hasDiscount = client.hasDiscount;
          ticket.tripSeat = {};
          ticket.tripSeat.trip = { id: vm.newTicket.selectedTrip.id };
          ticket.tripSeat.seatNumber = vm.selectedSeat[index].seatNumber;
          if (client.boarding) {
            ticket.boarding = {};
            ticket.boarding.id = client.boarding.id;
          }
          if (vm.newTicket.route.transfer) {
            ticket.isSubRoute = true;
            ticket.mainRoute = {};
            ticket.mainRoute = { id: vm.newTicket.routeRateOfTransfer };
          }
          payment.tickets.push(ticket);


          // First Way Transfer

          if (vm.newTicket.route.transfer) {
            ticket = {};
            ticket.client = { id: client.id };
            ticket.hasDiscount = client.hasDiscount;
            ticket.tripSeat = {};
            ticket.tripSeat.trip = { id: vm.newTicket.selectedTripT.id };
            ticket.tripSeat.seatNumber = vm.selectedSeatT[index].seatNumber;
            if (client.boardingT) {
              ticket.boarding = {};
              ticket.boarding.id = client.boardingT.id;
            }
            ticket.isSubRoute = true;
            ticket.mainRoute = {};
            ticket.mainRoute = { id: vm.newTicket.routeRateOfTransfer };

            payment.tickets.push(ticket);
          }

          // RETURN way ticket
          ticket = {};
          ticket.client = { id: client.id };
          ticket.hasDiscount = client.hasDiscount;
          ticket.tripSeat = {};
          ticket.tripSeat.trip = { id: vm.newTicket.selectedReturnTrip.id };
          ticket.tripSeat.seatNumber = vm.selectedReturnSeat[index].seatNumber;

          if (client.returnBoarding) {
            ticket.boarding = {};
            ticket.boarding.id = client.returnBoarding.id;
          }

          if (vm.newTicket.returnRoute.transfer) {
            ticket.isSubRoute = true;
            ticket.mainRoute = {};
            ticket.mainRoute = { id: vm.newTicket.returnRouteRateOfTransfer };
          }
          payment.tickets.push(ticket);

          // RETURN Way Transfer

          if (vm.newTicket.returnRoute.transfer) {
            ticket = {};
            ticket.client = { id: client.id };
            ticket.hasDiscount = client.hasDiscount;
            ticket.tripSeat = {};
            ticket.tripSeat.trip = { id: vm.newTicket.selectedReturnTripT.id };

            ticket.tripSeat.seatNumber = vm.selectedReturnSeatT[index].seatNumber;
            if (client.returnBoardingT) {
              ticket.boarding = {};
              ticket.boarding.id = client.returnBoardingT.id;
            }
            ticket.isSubRoute = true;
            ticket.mainRoute = {};
            ticket.mainRoute = { id: vm.newTicket.returnRouteRateOfTransfer };

            payment.tickets.push(ticket);
          }
        } else if (vm.newticket.typeOfTrip == 3) {
          if (client.boarding) {
            ticket.boarding = {};
            ticket.boarding.id = client.boarding.id;
          }
          ticket.routeRate = vm.openRouteRate;
          ticket.status = 'OPEN';

          payment.tickets.push(ticket);
        }

      });


      rTicket.save(payment, function (result) {
        toastr.success('Ticket vendido');
        vm.ticketsPaid = true;

        vm.invoices = result;

        angular.element('#modalTicketInvoice').modal({ backdrop: 'static', keyboard: false });
        vm.paymentInProgress = false;
        vm.loading = false;
      }, function (error) {
        toastr.error('Error al comprar', error.data.message);
        vm.paymentInProgress = false;
        vm.loading = false;
      });

    }

    /*TODO: SORT*/

    function resetOriginTrip() {
      vm.schedulesAvailable = [];
      vm.returnSchedulesAvailable = [];
      vm.allSeats = [];
      vm.returnAllSeats = [];
      vm.selectedSeat = [];

      vm.originDateUI = '';
    }

    function resetReturnTrip() {
      vm.returnSchedulesAvailable = [];
      vm.returnAllSeats = [];
      vm.selectedReturnSeat = [];
    }


    function init() {

      $(document).on('click', '.steps-indicator .done a', function () {
        if (this.text == 'Búsqueda') {
          changeLayout(true);
        }
      });

      bsLoadingOverlayService.start({ referenceId: 'ticket-overlay' });
      authenticationService.login(credentials)
      .then(function () {
        loadRoutes();
        loadBusClasses();
        bsLoadingOverlayService.stop({ referenceId: 'ticket-overlay' });

      }, function () {

        toastr.error('Venta en Linea No disponible en este momento');
        bsLoadingOverlayService.start({ referenceId: 'ticket-overlay' });

      });

    }


    restartTicketsEvent = $rootScope.$on('restartTicketsEvent', function () {
      restartTickets()
    });

    $rootScope.$on('$destroy', restartTicketsEvent);
  }
})();

(function () {
  'use strict';

  angular
  .module('tnsp')
  .controller('PaymentResultController', PaymentResultController);

  /** @ngInject */
  function PaymentResultController($window, $location, $rootScope) {
    var vm = this;

    vm.completePayment = completePayment;
    vm.response = $location.search();

    function completePayment() {


      setTimeout(function () {
        //$window.close();
      }, 500);
    }
  }
})();

(function () {
  'use strict';

  angular
  .module('tnsp')
  .controller('PaymentController', PaymentController);

  /** @ngInject */
  function PaymentController($window, md5, $rootScope, $location) {
    var vm = this,
      currentUtcTime = Math.floor(new Date() / 1000),
      ticketData;

    vm.formFields = {};

    window.addEventListener('message', onParentSubmit, false);

    checkQueryString();

    function prepareHash() {
      var hashString = vm.formFields.orderId + '|' + vm.formFields.amount + '|' + vm.formFields.time + '|' + '47J56Gnz8EDstq2YYTwUdw227atDqX29';
      vm.formFields.hash = md5.createHash(hashString);

      setTimeout(function () {
        var form = document.querySelector('form');
        form && form.submit();
      }, 1000);
    }

    function onParentSubmit(e) {
      var data;

      $rootScope.$apply(function () {

        if (typeof e.data !== 'object') {
          data = JSON.parse(e.data);
          ticketData = data;

          vm.formFields = {
            orderId: (ticketData && ticketData.orderKey) ? ticketData.orderKey : 0,
            ccnumber: ticketData.cardNumber,
            ccexp: ticketData.exp,
            cvv: ticketData.cvv,

            keyId: 8464420,
            processorId: 'transnicadol',
            time: currentUtcTime,
            type: 'sale',
            amount: parseFloat(ticketData.total).toFixed(2),
            redirect: 'https://ventas.transnica.com/#/payment'
            // redirect: 'http://localhost:3000/payment'
          };
          prepareHash();
        }

      });
    }

    function checkQueryString() {
      vm.response = $location.search();
      if (vm.response && vm.response.response_code) {
        window.parent.postMessage(JSON.stringify(vm.response), '*');
      }
    }
  }
})
();

(function() {
  'use strict';

  angular
    .module('tnsp')
    .directive('tnspSidebar', tnspSidebar);

  /** @ngInject */
  function tnspSidebar() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/sidebar/sidebar.html',
      controller: SidebarController,
      controllerAs: 'sidebar',
      scope:{
        title: '@'
      },
      bindToController: true
    };

    return directive;

    /** @ngInject */
    function SidebarController($rootScope, $state, HEADER_MENU, SIDEBAR_MENU) {
      var vm = this,
        onRolesLoaded;

      vm.selectedItem = $state.current.name;
      vm.selectedItem = vm.selectedItem.split('.')[0];
      vm.items  = [];
      vm.sideBarItems = SIDEBAR_MENU;

      onRolesLoaded = $rootScope.$on('rolesLoaded', function() {
        loadSidebar();
      });

      $rootScope.$on('$destroy', onRolesLoaded);


      function loadSidebar(){
        vm.items  = [];
        angular.forEach(HEADER_MENU, function(item) {
          if (item.routerState === vm.selectedItem){
            vm.items = item.subNavItems;
            /*if ($rootScope.user.sysAdmin){
              $scope.items = item.subNavItems;
            }else{
              if ($rootScope.userPermissions){
                angular.forEach(item.subNavItems, function(subItem){

                  if ($rootScope.isTenantAdmin && subItem.url !== '.roles'){
                    $scope.items.push(subItem);
                  }else{
                    angular.forEach(subItem.requiredPermissions, function(permissions){
                      if ($rootScope.userPermissions.indexOf(permissions) > -1){
                        $scope.items.push(subItem);
                      }
                    });
                  }
                });
              }
            }*/
          }
        });
      }

      loadSidebar();
    }
  }

})();

(function() {
  'use strict';

  angular
    .module('tnsp')
    .directive('selectpicker', Selectpicker);

  /** @ngInject */
  function Selectpicker() {
    var directive = {
      restrict: 'A',
      scope:true,
      link:SelectpickerLink
    };

    return directive;

    /** @ngInject */
    function SelectpickerLink(scope, element, iAttrs){
      scope.$watchCollection(iAttrs['selectpicker'], function(){
        element.selectpicker();
      });
    }
  }

})();

(function () {
  'use strict';

  angular
    .module('tnsp')
    .directive('tnspModalTerms', tnspModalTerms);

  /* @ngInject */
  function tnspModalTerms() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/modal-terms/modal-terms.html',
      controller: ModalTermsController,
      controllerAs: 'mtermsForm',
      bindToController: true,
      scope: {
        tickets: '='
      }
    };

    return directive;

    /* @ngInject */
    function ModalTermsController(toastr, $rootScope, $timeout, $log) {
      var vm = this;

      function init() {}

      angular.element('#modalRegulations').on('show.bs.modal', function () {
        $timeout(function(){
          init();
        },100);
      });

    }
  }

})();

(function () {
  'use strict';

  angular
    .module('tnsp')
    .directive('tnspModalSeatsForm', tnspModalSeatsForm);

  /* @ngInject */
  function tnspModalSeatsForm() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/modal-seats-form/modal-seats-form.html',
      controller: ModalSeatsController,
      controllerAs: 'mSeatsForm',
      bindToController: true,
      scope: {
        tickets: '='
      }
    };

    return directive;

    /* @ngInject */
    function ModalSeatsController(toastr, $rootScope, $timeout, $log) {
      var vm = this;
      vm.submitProcess = submitProcess;

      function init() {
        vm.tickets.refreshSeats();
      }

      function submitProcess(form) {
        vm.loading = true;
        if(!form.$valid) {
          vm.loading = false;
          vm.submitAttempt = true;
          return;
        }
        vm.tickets.goToConfirmation(form);
      }

      angular.element('#modalSeatsForm').on('shown.bs.modal', function () {
        vm.submitAttempt = false;
        $timeout(function(){
          init();
        },100);
      });

    }
  }

})();

(function () {
  'use strict';

  angular
    .module('tnsp')
    .directive('tnspModalRegulations', tnspModalRegulations);

  /* @ngInject */
  function tnspModalRegulations() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/modal-regulations/modal-regulations.html',
      controller: ModalRegulationsController,
      controllerAs: 'mregulationsForm',
      bindToController: true,
      scope: {
        tickets: '='
      }
    };

    return directive;

    /* @ngInject */
    function ModalRegulationsController(toastr, $rootScope, $timeout, $log) {
      var vm = this;
      vm.submitProcess = submitProcess;

      function init() {}

      function submitProcess(form) {
        vm.loading = true;
        if(!form.$valid) {
          vm.loading = false;
          vm.submitAttempt = true;
          return;
        }
        vm.tickets.goToConfirmation(form);
      }

      angular.element('#modalRegulations').on('show.bs.modal', function () {
        vm.submitAttempt = false;
        $timeout(function(){
          init();
        },100);
      });

    }
  }

})();

(function () {
  'use strict';

  angular
  .module('tnsp')
  .directive('tnspModalPrintTicketInvoice', tnspModalPrintTicketInvoice);

  /* @ngInject */
  function tnspModalPrintTicketInvoice() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/modal-print-ticket-invoice/modal-print-ticket-invoice.html',
      controller: ModalPrintTicketInvoiceController,
      controllerAs: 'mTicketInvoice',
      bindToController: true,
      scope: {
        invoicesIds: '=',
        showPreview: '=',
        transactionNumber: '='
      }
    };

    return directive;

    /* @ngInject */
    function ModalPrintTicketInvoiceController($rootScope, rTicket, rTicketInvoice, moment, printService, DATE_TIME_FORMAT, DATE_FORMAT, toastr) {
      var vm = this;
      vm.loading = false;
      vm.print = print;
      vm.sms = sms;
      vm.dateTimeFormat = DATE_TIME_FORMAT;
      vm.dateFormat = DATE_FORMAT;
      vm.invoices = [];
      vm.now = moment();

      function init() {
        loadInvoices();
      }

      function loadInvoices() {
        vm.invoices = [];
        angular.forEach(vm.invoicesIds, function (invoiceId) {
          rTicketInvoice.query({ id: invoiceId.invoiceNumber }, function (result) {
            vm.invoices.push(result);
          });
        });

      }

      angular.element('#modalTicketInvoice').on('shown.bs.modal', function () {
        init();
      });

      angular.element('#modalTicketInvoice').on('hidden.bs.modal', function () {
        $rootScope.$broadcast('restartTicketsEvent');
      });


      function sms() {
        angular.forEach(vm.invoicesIds, function (invoiceId) {
          rTicket.sendSMS({ id: invoiceId.invoiceNumber }, function () {
            toastr.success('SMS enviado');
          });
        });


      }

      function print() {
        vm.loading = true;
        /* eslint-disable */
        var printContents = document.getElementById('printableArea').innerHTML;
        printService.print("printableAreaFrame", printContents);
        /* eslint-enable */

        if (sms) {
          sms();
        }

        setTimeout(function () {
          vm.loading = false;
        }, 2000);
      }

    }
  }

})();

(function () {
  'use strict';

  angular
    .module('tnsp')
    .directive('tnspModalClientForm', tnspModalClientForm);

  /* @ngInject */
  function tnspModalClientForm() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/modal-client-form/modal-client-form.html',
      controller: ModalClientController,
      controllerAs: 'mClientForm',
      bindToController: true,
      scope: {
        client: '='
      }
    };

    return directive;

    /* @ngInject */
    function ModalClientController(rClient, toastr, $rootScope, $timeout, rUser,rNationality, CIVIL_STATUS, GENRES) {
      var vm = this;
      vm.identificationTypes = [];
      vm.civilStatues = CIVIL_STATUS;
      vm.genres = GENRES;
      vm.type = 'create';
      vm.submitProcess = submitProcess;
      vm.openIECalendar = openIECalendar;
      vm.openBDCalendar = openBDCalendar;

      loadIdentificationTypes();
      loadNationalities();

      function init() {
        if(vm.client) {
          loadClient();
          vm.type = 'edit';
        }else{
          vm.type = 'create';
          vm.client = {};
        }
      }

      function loadClient() {
        rClient.query({id: vm.client.id}, function(result){
          vm.client = result;
        });
      }

      function loadIdentificationTypes() {
        rUser.getIdentificationTypes({}, function(result){
          vm.identificationTypes = result;
        });
      }

      function loadNationalities() {
        rNationality.query({}, function(result){
          vm.nationalities = result;
        });
      }

      function submitProcess(form) {
        vm.loading = true;
        if(!form.$valid) {
          vm.loading = false;
          vm.submitAttempt = true;
          return;
        }
        if(vm.type === 'create') {
          createProcess()
        }else{
          updateProcess()
        }
      }

      function createProcess() {
        rClient.save(vm.client, function() {
          angular.element('#modalClientForm').modal('hide');
          vm.loading = false;
          toastr.success('El Cliente fue creado satisfactoriamente');
          $rootScope.$broadcast('clientCreated');
        }, function(error){
          vm.loading = false;
          toastr.error('Hubo un error al crear el cliente', error.data.message);
        });
      }

      function updateProcess() {
        rClient.update(vm.client, function() {
          angular.element('#modalClientForm').modal('hide');
          toastr.success('El cliente fue editado satisfactoriamente');
          $rootScope.$broadcast('clientUpdated');
          vm.loading = false;
        }, function(error){
          vm.loading = false;
          toastr.error('Hubo un error al editar el cliente', error.data.message);
        });
      }

      function openIECalendar(){
        vm.showIECalendar = true;
      }
      function openBDCalendar(){
        vm.showBDCalendar = true;
      }

      angular.element('#modalClientForm').on('show.bs.modal', function () {
        vm.submitAttempt = false;
      });

      angular.element('#modalClientForm').on('shown.bs.modal', function () {
        $timeout(function(){
          init();
        },10);
      });

    }
  }

})();

(function() {
  'use strict';

  angular
    .module('tnsp')
    .directive('tnspHeader', tnspHeader);

  /** @ngInject */
  function tnspHeader() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/header/header.html',
      controller: HeaderController,
      controllerAs: 'header',
      bindToController: true
    };

    return directive;

    /** @ngInject */
    function HeaderController($log, HEADER_MENU, HEADER_SECONDARY_MENU, SOCIAL_MENU) {
      var vm = this;

      vm.menu = HEADER_MENU;
      vm.secondaryMenu = HEADER_SECONDARY_MENU;
      vm.socialMenu = SOCIAL_MENU;
    }
  }

})();

(function() {
  'use strict';

  angular
    .module('tnsp')
    .directive('tnspFooter', tnspFooter);

  /** @ngInject */
  function tnspFooter(FOOTER_MENU) {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/footer/footer.html',
      controller: FooterController,
      controllerAs: 'footer',
      bindToController: true
    };

    return directive;

    /** @ngInject */
    function FooterController() {
      var vm = this;

      vm.menu = FOOTER_MENU;

    }
  }

})();

(function() {
  'use strict';

  angular
    .module('tnsp')
    .directive('enterKey', enterKey);

  /** @ngInject */
  function enterKey() {
    var directive = {
      restrict: 'A',
      scope:true,
      link:SelectpickerLink
    };

    return directive;

    /** @ngInject */
    function SelectpickerLink(scope, element, attrs){
      element.bind('keydown keypress', function(event) {
        var keyCode = event.which || event.keyCode;

        // If enter key is pressed
        if (keyCode === 13) {
          scope.$apply(function() {
            // Evaluate the expression
            scope.$eval(attrs.enterKey);
          });

          event.preventDefault();
        }
      });
    }
  }

})();

(function() {
  'use strict';

  angular
    .module('tnsp')
    .factory('utilsService', cacheService);

  function cacheService() {

    function isObjectOnList(obj, list, key) {
      var found = false;
      angular.forEach(list, function (item) {
        if (item[key] === obj[key]) {
          found = true;
        }
      });

      return found;
    }


    return {
      isObjectOnList:isObjectOnList
    };
  }
})();

(function() {
  'use strict';

  angular
    .module('tnsp')
    .factory('printService', printService);

  function printService() {


    function print(divName, printContents) {
      /* eslint-disable */
      var newWin = window.frames[divName];
      var links_html = "";
      angular.forEach(document.getElementsByTagName('link'), function(value, key) {
        links_html += value.outerHTML + ' '
      });
      newWin.document.write('<html><head>' + links_html + '</head><body onload="window.print()">' + printContents + '</body></html>');
      newWin.document.close();
      /* eslint-enable */
    }


    return {
      print: print
    };
  }
})();

(function() {
  'use strict';

  /*global $*/

  angular
    .module('tnsp')
    .factory('authenticationService', authenticationService);

  function authenticationService( $q, $http, $rootScope, $state, $window, rUser) {
    var loginInfo,
      isUserloggedIn = false,
      loggedUserInfo = null;

    var credentials = {
      grantType:'password',
      userName:'',
      password:'',
      clientId:'transnica-trusted-client',
      clientSecret:'secret'
    };

    function login(_credentials){
      var deferred = $q.defer();

      credentials.userName =_credentials.userName;
      credentials.password =_credentials.password;

      $http({
        url: 'api/oauth/token',
        method: 'POST',
        headers: {'Content-Type': 'application/x-www-form-urlencoded'},
        data: $.param({
          grant_type:credentials.grantType,
          username:credentials.userName,
          password:credentials.password,
          client_id:credentials.clientId,
          client_secret:credentials.clientSecret
        })
      })
        .then(function(result){
            loginInfo = {
              accessToken: result.data.access_token,
              refreshToken: result.data.refresh_token,
              userId: result.data.user_id
            };

            $window.sessionStorage['loginInfo'] = angular.toJson(loginInfo);

            $http.defaults.headers.common.Authorization = 'Bearer ' + loginInfo.accessToken;
            isUserloggedIn = true;

            rUser.query({id:loginInfo.userId}, function(result){
              loggedUserInfo = result;
              $window.sessionStorage['userInfo'] = angular.toJson(loggedUserInfo);
              deferred.resolve(loginInfo);
            });

          },
          function(error){
            isUserloggedIn = false;
            $http.defaults.headers.common.Authorization = '' ;
            deferred.reject(error);
          });

      return deferred.promise;
    }

    function logout(){
      angular.element('.modal').hide();
      isUserloggedIn = false;
      loginInfo = {};
      loggedUserInfo = {};
      $http.defaults.headers.common.Authorization = '' ;
      $window.sessionStorage.clear();
    }

    function refreshUserInfo(userId){
      rUser.query({id:userId}, function(result){
        loggedUserInfo = result;
        $window.sessionStorage['userInfo'] = angular.toJson(loggedUserInfo);
        $rootScope.$broadcast('userRefreshed');
      });
    }

    function checkPermissions(){
      //TODO: Check Roles or permissions 
      return true;
    }

    function isLoggedIn(){
      return isUserloggedIn;
    }
    function getLoginInfo() {
      return loginInfo;
    }
    function getUserInfo() {
      return loggedUserInfo;
    }
    function getAllAuthInfo(){
      return {isLoggedIn:isUserloggedIn, userInfo:loggedUserInfo}
    }

    function init() {
      if ($window.sessionStorage['loginInfo']) {
        loginInfo = angular.fromJson($window.sessionStorage['loginInfo']);
        isUserloggedIn = true;
        $http.defaults.headers.common.Authorization = 'Bearer ' + loginInfo.accessToken;

        if ($window.sessionStorage['userInfo']) {
          loggedUserInfo = angular.fromJson($window.sessionStorage['userInfo']);
        }else{
          rUser.query({id:loginInfo.userId}, function(result){
            loggedUserInfo = result;
            $window.sessionStorage['userInfo'] = angular.toJson(loggedUserInfo);
          });
        }
      }
    }

    init();


    return {
      login: login,
      logout:logout,
      isLoggedIn: isLoggedIn,
      getLoginInfo:getLoginInfo,
      getUserInfo:getUserInfo,
      refreshUserInfo:refreshUserInfo,
      getAllAuthInfo: getAllAuthInfo,
      checkPermissions:checkPermissions
    };
  }
})();

(function() {
	'use strict';


	angular.module('tnsp')
	.factory('authHttpResponseInterceptor', function($q, $rootScope) {
		return {
			response: function(response) {
				if(response.status === 401) {
					$rootScope.$broadcast('401UnauthorizedError');
				}
				return response || $q.when(response);
			},
			responseError: function(rejection) {
				if(rejection.status === 401) {
					$rootScope.$broadcast('401UnauthorizedError');
				}
				return $q.reject(rejection);
			}
		};
	});
})();

(function() {
'use strict';

angular
  .module('tnsp')
  .factory('rUser', function($resource) {
    return $resource('api/users/:id', {
      id: '@id'
    },
    {
      'delete': {
        method: 'DELETE',
        url: 'api/users/:id',
        params:{
          id: '@id'
        }
      },
      'query': {
        method: 'GET',
        url: 'api/users/:id',
        params:{
          id:'@id'
        }
      },
      'save': {
        method: 'POST',
        url: 'api/users'
      },
      'update': {
        method: 'PUT',
        url: 'api/users/:id',
        params:{
          id:'@id'
        }
      },
      'getIdentificationTypes': {
        method: 'GET',
        url: 'api/identificationtypes/:id',
        params:{
          id:'@id'
        },
        isArray: true
      }
    });
  });
})();

(function() {
'use strict';
angular
  .module('tnsp')
  .factory('rTrip', function($resource) {
    return $resource('api/trips/:id', {
      id: '@id'
    },
    {
      'delete': {
        method: 'DELETE',
        url: 'api/trips/:id',
        params:{
          id: '@id'
        }
      },
      'query': {
        method: 'GET',
        url: 'api/trips/:id',
        params:{
          id: '@id'
        }
      },
      'save': {
        method: 'POST',
        url: 'api/trips/'
      },
      'update': {
        method: 'PUT',
        url: 'api/trips/:id',
        params:{
          id: '@id'
        }
      },
      'patchTrip': {
        method: 'PATCH',
        url: 'api/trips/:id',
        params:{
          id: '@id'
        }
      },
      'getOccupiedSeats': {
        method: 'GET',
        url: 'api/trips/:id/seats',
        params:{
          id: '@id'
        },
        isArray:true
      },
      'getTickets': {
        method: 'GET',
        url: 'api/trips/:id/tickets',
        params:{
          id: '@id'
        },
        isArray:true
      },
      'release': {
        method: 'POST',
        url: 'api/trips/:id/release',
        params:{
          id: '@id'
        }
      }
    });
  });
})();

(function() {
'use strict';
angular
  .module('tnsp')
  .factory('rTicketInvoice', function($resource) {
    return $resource('api/ticketinvoices/:id', {
      id: '@id'
    },
    {
      'query': {
        method: 'GET',
        url: 'api/ticketinvoices/:id',
        params:{
          id: '@id'
        }
      }
    });
  });
})();

(function() {
  'use strict';
  angular
  .module('tnsp')
  .factory('rTicket', function($resource) {
    return $resource('api/tickets/:id', {
        id: '@id'
      },
      {
        'delete': {
          method: 'DELETE',
          url: 'api/tickets/:id',
          params:{
            id: '@id'
          }
        },
        'query': {
          method: 'GET',
          url: 'api/tickets/:id',
          params:{
            id: '@id'
          }
        },
        'save': {
          method: 'POST',
          url: 'api/tickets/',
          isArray:true
        },
        'update': {
          method: 'PUT',
          url: 'api/tickets/:id',
          params:{
            id: '@id'
          }
        },
        'partialUpdate': {
          method: 'PATCH',
          url: 'api/tickets/:id',
          params:{
            id: '@id'
          }
        },
        'reserve': {
          method: 'POST',
          url: 'api/tickets/reserve'
        },
        'cancelReserve': {
          method: 'POST',
          url: 'api/tickets/cancelreserve'
        },
        'checkin': {
          method: 'POST',
          url: 'api/tickets/:id/checkin',
          params:{
            id: '@id'
          }
        },
        'cancel': {
          method: 'POST',
          url: 'api/tickets/:id/cancel',
          params:{
            id: '@id'
          }
        },
        'redeem': {
          method: 'POST',
          url: 'api/tickets/:id/redeem',
          params:{
            id: '@id'
          }
        },
        'registerLuggage':{
          method: 'POST',
          url: 'api/tickets/:id/luggage',
          params:{
            id: '@id'
          }
        },
        'getLuggage':{
          method: 'GET',
          url: 'api/tickets/:id/luggage',
          params:{
            id: '@id'
          },
          isArray:true
        },
        'release': {
          method: 'POST',
          url: 'api/tickets/:id/release',
          params:{
            id: '@id'
          }
        },
        'sendSMS': {
          method: 'POST',
          url: 'api/tickets/:id/sms',
          params:{
            id: '@id'
          }
        }
      });
  });
})();

(function() {
  'use strict';
  angular
    .module('tnsp')
    .factory('rTerminal', function($resource) {
      return $resource('api/terminals/:id', {
          id: '@id'
        },
        {
          'delete': {
            method: 'DELETE',
            url: 'api/terminals/:id',
            params:{
              id: '@id'
            }
          },
          'query': {
            method: 'GET',
            url: 'api/terminals/:id',
            params:{
              id: '@id'
            }
          },
          'save': {
            method: 'POST',
            url: 'api/terminals/'
          },
          'update': {
            method: 'PUT',
            url: 'api/terminals/:id',
            params:{
              id: '@id'
            }
          }
        });
    });
})();

(function() {
  'use strict';

  angular
    .module('tnsp')
    .factory('rSchedule', function($resource) {
      return $resource('api/routes/:routeId/schedules/:id', {
          id: '@id'
        },
        {
          'delete': {
            method: 'DELETE',
            url: 'api/routes/:routeId/schedules/:id',
            params:{
              id: '@id'
            }
          },
          'query': {
            method: 'GET',
            url: 'api/routes/:routeId/schedules/:id',
            params:{
              id:'@id',
              routeId: '@routeId'
            }
          },
          'save': {
            method: 'POST',
            url: 'api/routes/:routeId/schedules/:id',
            params:{
              id:'@id',
              routeId: '@routeId'
            }
          },
          'update': {
            method: 'PUT',
            url: 'api/routes/:routeId/schedules/:id',
            params:{
              id:'@id',
              routeId: '@routeId'
            }
          }
        });
    });
})();

(function() {
  'use strict';

  angular
    .module('tnsp')
    .factory('rRouteRate', function($resource) {
      return $resource('api/routes/:routeId/routerates/:id', {
          id: '@id',
          routeId: '@routeId'
        },
        {
          'delete': {
            method: 'DELETE',
            url: 'api/routes/:routeId/routerates/:id',
            params:{
              id: '@id'
            }
          },
          'query': {
            method: 'GET',
            url: 'api/routes/:routeId/routerates/:id',
            params:{
              id:'@id'
            }
          },
          'save': {
            method: 'POST',
            url: 'api/routes/:routeId/routerates/:id',
            params:{
              id:'@id',
              routeId: '@routeId'
            }
          },
          'update': {
            method: 'PUT',
            url: 'api/routes/:routeId/routerates/:id',
            params:{
              id:'@id',
              routeId: '@routeId'
            }
          }
        });
    });
})();

(function() {
'use strict';
angular
  .module('tnsp')
  .factory('rRoute', function($resource) {
    return $resource('api/routes/:id', {
      id: '@id'
    },
    {
      'delete': {
        method: 'DELETE',
        url: 'api/routes/:id',
        params:{
          id: '@id'
        }
      },
      'query': {
        method: 'GET',
        url: 'api/routes/:id',
        params:{
          id: '@id'
        }
      },
      'save': {
        method: 'POST',
        url: 'api/routes/'
      },
      'update': {
        method: 'PUT',
        url: 'api/routes/:id',
        params:{
          id: '@id'
        }
      }
    });
  });
})();

(function() {
  'use strict';
  angular
    .module('tnsp')
    .factory('rReseller', function($resource) {
      return $resource('api/resellers/:id', {
          id: '@id',
          resellerId: '@resellerId'
        },
        {
          'delete': {
            method: 'DELETE',
            url: 'api/resellers/:id',
            params:{
              id: '@id'
            }
          },
          'query': {
            method: 'GET',
            url: 'api/resellers/:id',
            params:{
              id: '@id'
            }
          },
          'save': {
            method: 'POST',
            url: 'api/resellers/'
          },
          'update': {
            method: 'PUT',
            url: 'api/resellers/:id',
            params:{
              id: '@id'
            }
          },
          'addUser': {
            method: 'POST',
            url: 'api/resellers/:resellerId/users/:id',
            params:{
              id:'@id',
              routeId: '@resellerId'
            }
          },
          'deleteUser': {
            method: 'DELETE',
            url: 'api/resellers/:resellerId/users/:id',
            params:{
              id:'@id',
              routeId: '@resellerId'
            }
          }
        });
    });
})();

(function() {
'use strict';

angular
  .module('tnsp')
  .factory('rProfile', function($resource) {
    return $resource('api/roles/:id', {
      id: '@id'
    },
    {
      'delete': {
        method: 'DELETE',
        url: 'api/roles/:id',
        params:{
          id: '@id'
        }
      },
      'query': {
        method: 'GET',
        url: 'api/roles/:id',
        params:{
          id:'@id'
        }
      },
      'save': {
        method: 'POST',
        url: 'api/roles'
      },
      'update': {
        method: 'PUT',
        url: 'api/roles/:id',
        params:{
          id:'@id'
        }
      }
    });
  });
})();

(function() {
'use strict';

angular
  .module('tnsp')
  .factory('rPermission', function($resource) {
    return $resource('api/permissions/:id', {
      id: '@id'
    },
    {
      'delete': {
        method: 'DELETE',
        url: 'api/permissions/:id',
        params:{
          id: '@id'
        }
      },
      'query': {
        method: 'GET',
        url: 'api/permissions/:id',
        params:{
          id:'@id'
        }
      },
      'save': {
        method: 'POST',
        url: 'api/permissions/:id'
      },
      'update': {
        method: 'PUT',
        url: 'api/permissions/:id',
        params:{
          id:'@id'
        }
      }
    });
  });
})();

(function() {
  'use strict';
  angular
    .module('tnsp')
    .factory('rPassword', function($resource) {
      return $resource('api/forgotpassword', {
      },{
        'forgot': {
          method: 'POST',
          url: 'api/forgotpassword'
        },
        'reset': {
          method: 'POST',
          url: 'api/resetpassword/'
        }
      });
    });

})();

(function() {
'use strict';
angular
  .module('tnsp')
  .factory('rPackingType', function($resource) {
    return $resource('api/packingtypes/:id', {
      id: '@id'
    },
    {
      'delete': {
        method: 'DELETE',
        url: 'api/packingtypes/:id',
        params:{
          id: '@id'
        }
      },
      'query': {
        method: 'GET',
        url: 'api/packingtypes/:id',
        params:{
          id: '@id'
        }
      },
      'save': {
        method: 'POST',
        url: 'api/packingtypes/'
      },
      'update': {
        method: 'PUT',
        url: 'api/packingtypes/:id',
        params:{
          id: '@id'
        }
      }
    });
  });
})();

(function() {
'use strict';

angular
  .module('tnsp')
  .factory('rNationality', function($resource) {
    return $resource('api/nationalities/:id', {
      id: '@id'
    },
    {
      'delete': {
        method: 'DELETE',
        url: 'api/nationalities/:id',
        params:{
          id: '@id'
        }
      },
      'query': {
        method: 'GET',
        url: 'api/nationalities/:id',
        params:{
          id:'@id'
        },
        isArray:true
      },
      'save': {
        method: 'POST',
        url: 'api/nationalities/:id'
      },
      'update': {
        method: 'PUT',
        url: 'api/nationalities/:id',
        params:{
          id:'@id'
        }
      }
    });
  });
})();

(function() {
  'use strict';
  angular
    .module('tnsp')
    .factory('rInvoice', function($resource) {
      return $resource('api/invoices/:id', {
          id: '@id'
        },
        {
          'query': {
            method: 'GET',
            url: 'api/invoices/:id',
            params:{
              id: '@id'
            }
          }
        });
    });
})();

(function() {
'use strict';

angular
  .module('tnsp')
  .factory('rExchange', function($resource) {
    return $resource('api/exchanges/:id', {
      id: '@id'
    },
    {
      'delete': {
        method: 'DELETE',
        url: 'api/exchanges/:id',
        params:{
          id: '@id'
        }
      },
      'query': {
        method: 'GET',
        url: 'api/exchanges/:id',
        params:{
          id:'@id'
        }
      },
      'save': {
        method: 'POST',
        url: 'api/exchanges/:id'
      },
      'update': {
        method: 'PUT',
        url: 'api/exchanges/:id',
        params:{
          id:'@id'
        }
      }
    });
  });
})();

(function() {
'use strict';

angular
  .module('tnsp')
  .factory('rCurrency', function($resource) {
    return $resource('api/currencies/:id', {
      id: '@id'
    },
    {
      'delete': {
        method: 'DELETE',
        url: 'api/currencies/:id',
        params:{
          id: '@id'
        }
      },
      'query': {
        method: 'GET',
        url: 'api/currencies/:id',
        params:{
          id:'@id'
        }
      },
      'save': {
        method: 'POST',
        url: 'api/currencies/:id'
      },
      'update': {
        method: 'PUT',
        url: 'api/currencies/:id',
        params:{
          id:'@id'
        }
      }
    });
  });
})();

(function() {
'use strict';

angular
  .module('tnsp')
  .factory('rCountry', function($resource) {
    return $resource('api/countries/:id', {
      id: '@id'
    },
    {
      'delete': {
        method: 'DELETE',
        url: 'api/countries/:id',
        params:{
          id: '@id'
        }
      },
      'query': {
        method: 'GET',
        url: 'api/countries/:id',
        params:{
          id:'@id'
        }
      },
      'save': {
        method: 'POST',
        url: 'api/countries/:id'
      },
      'update': {
        method: 'PUT',
        url: 'api/countries/:id',
        params:{
          id:'@id'
        }
      },
      'getTerminals': {
        method: 'GET',
        url: 'api/countries/:countryId/terminals/:id',
        params:{
          id: '@id',
          countryId:'@countryId'
        }
      }
    });
  });
})();

(function() {
  'use strict';
  angular
    .module('tnsp')
    .factory('rClient', function($resource ,$http, DATE_ISO_FORMAT, moment) {
      return $resource('api/clients/:id', {
          id: '@id'
        },
        {
          'delete': {
            method: 'DELETE',
            url: 'api/clients/:id',
            params:{
              id: '@id'
            }
          },
          'query': {
            method: 'GET',
            url: 'api/clients/:id',
            params:{
              id: '@id'
            },
            transformResponse: $http.defaults.transformRequest.concat(transformResponse)
          },
          'save': {
            method: 'POST',
            url: 'api/clients/',
            transformRequest: [transformRequest].concat($http.defaults.transformRequest)
          },
          'update': {
            method: 'PUT',
            url: 'api/clients/:id',
            params:{
              id: '@id'
            },
            transformRequest: [transformRequest].concat($http.defaults.transformRequest)
          }
        });

      function transformResponse(response) {
        try {
          var clientResponse = angular.fromJson(response);

          if(clientResponse.records) {
            angular.forEach(clientResponse.records, function(client) {
              client.identificationExpirationUI =  client.identificationExpiration ? moment(client.identificationExpiration, DATE_ISO_FORMAT).toDate() : '';
              client.birthdateUI =  client.birthdate ? moment(client.birthdate, DATE_ISO_FORMAT).toDate() : '';
            });
          } else {
            clientResponse.identificationExpirationUI =  clientResponse.identificationExpiration ? moment(clientResponse.identificationExpiration, DATE_ISO_FORMAT).toDate() : '';
            clientResponse.birthdateUI =  clientResponse.birthdate ? moment(clientResponse.birthdate, DATE_ISO_FORMAT).toDate() : '';

          }
          return clientResponse;
        } catch(e) {
          return angular.fromJson(response);
        }
      }

      function transformRequest(request) {
        if(!request) {return null;}

        if(request.identificationExpirationUI !== null && request.identificationExpirationUI !==''){
          request.identificationExpiration = moment(request.identificationExpirationUI).format('YYYY-MM-DD');
          request.birthdate = moment(request.birthdateUI).format('YYYY-MM-DD');
        }

        return request;
      }
    });
})();

(function() {
  'use strict';

  angular
    .module('tnsp')
    .factory('rCashRegister', function($resource) {
      return $resource('api/terminals/:terminalId/cashregisters/:id', {
          id: '@id',
          terminalId: '@terminalId',
          cashRegisterId: '@cashRegisterId'
        },
        {
          'delete': {
            method: 'DELETE',
            url: 'api/terminals/:terminalId/cashregisters/:id',
            params:{
              id: '@id'
            }
          },
          'query': {
            method: 'GET',
            url: 'api/terminals/:terminalId/cashregisters/:id',
            params:{
              id:'@id'
            }
          },
          'save': {
            method: 'POST',
            url: 'api/terminals/:terminalId/cashregisters/:id',
            params:{
              id:'@id',
              terminalId: '@terminalId'
            }
          },
          'update': {
            method: 'PUT',
            url: 'api/terminals/:terminalId/cashregisters/:id',
            params:{
              id:'@id',
              terminalId: '@terminalId'
            }
          },
          'open': {
            method: 'POST',
            url: 'api/terminals/:terminalId/cashregisters/:id/open',
            params:{
              id:'@id',
              terminalId: '@terminalId'
            }
          },
          'close': {
            method: 'POST',
            url: 'api/terminals/:terminalId/cashregisters/:id/close',
            params:{
              id:'@id',
              terminalId: '@terminalId'
            }
          },
          'addMovement': {
            method: 'POST',
            url: 'api/terminals/:terminalId/cashregisters/:id/transactions',
            params:{
              id:'@id',
              terminalId: '@terminalId'
            }
          },
          'transactionTypes': {
            method: 'GET',
            url: 'api/transactiontypes',
            params:{
              id:'@id'
            },
            isArray:true
          },
          'balances': {
            method: 'GET',
            url: 'api/terminals/:terminalId/cashregisters/:cashRegisterId/balances/:id',
            params:{
              id:'@cashRegisterid',
              terminalId: '@terminalId',
              cashRegisterId: '@cashRegisterId'
            }
          }
        });
    });
})();

(function() {
'use strict';
angular
  .module('tnsp')
  .factory('rBus', function($resource) {
    return $resource('api/buses/:id', {
      id: '@id'
    },
    {
      'delete': {
        method: 'DELETE',
        url: 'api/buses/:id',
        params:{
          id: '@id'
        }
      },
      'query': {
        method: 'GET',
        url: 'api/buses/:id',
        params:{
          id: '@id'
        }
      },
      'save': {
        method: 'POST',
        url: 'api/buses/'
      },
      'update': {
        method: 'PUT',
        url: 'api/buses/:id',
        params:{
          id: '@id'
        }
      },
      'getBusClasses': {
        method: 'GET',
        url: 'api/busclasses',
        params:{
        }
      }
    });
  });
})();

(function() {
  'use strict';

  angular
    .module('tnsp')
    .factory('rBoarding', function($resource) {
      return $resource('api/routes/:routeId/boardings/:id', {
          id: '@id',
          routeId: '@routeId'
        },
        {
          'delete': {
            method: 'DELETE',
            url: 'api/routes/:routeId/boardings/:id',
            params:{
              id: '@id'
            }
          },
          'query': {
            method: 'GET',
            url: 'api/routes/:routeId/boardings/:id',
            params:{
              id:'@id'
            }
          },
          'save': {
            method: 'POST',
            url: 'api/routes/:routeId/boardings/:id',
            params:{
              id:'@id',
              routeId: '@routeId'
            }
          },
          'update': {
            method: 'PUT',
            url: 'api/routes/:routeId/boardings/:id',
            params:{
              id:'@id',
              routeId: '@routeId'
            }
          }
        });
    });
})();

(function() {
  'use strict';

  angular
    .module('tnsp')
    .run(runBlock);

  /** @ngInject */
  function runBlock(bsLoadingOverlayService, $state, $rootScope, authenticationService, $log, DATE_FORMAT, DATE_PICKER_FORMAT) {

    var APIAuthError,
      stateChange;

    $rootScope.dateFormat = DATE_FORMAT;
    $rootScope.datePickerFormat = DATE_PICKER_FORMAT;


    bsLoadingOverlayService.setGlobalConfig({
      delay: 50,
      activeClass: 'active-overlay',
      templateUrl: 'app/components/loading-overlay/loading-overlay.html'
    });

    stateChange = $rootScope.$on('$stateChangeSuccess', function(event, toState) {
      if(toState && toState.params){
        if(toState.params.autoActivateChild){
          $state.go(toState.params.autoActivateChild);
        }else if (toState.params.childList){
          $state.go(toState.params.childList[0].routerState);
        }
      }
    });


    APIAuthError = $rootScope.$on('401UnauthorizedError', function() {
      $log.error('Unauthorized');
    });

    $rootScope.$on('$destroy', APIAuthError);
    $rootScope.$on('$destroy', stateChange);
  }

})();

(function() {
  'use strict';

  angular
    .module('tnsp')
    .config(routerConfig);

  /** @ngInject */
  function routerConfig($stateProvider, $urlRouterProvider, $locationProvider) {

    $urlRouterProvider.otherwise('/');

    $stateProvider
    .state('tickets', {
      url: '/',
      templateUrl: 'app/pages/sales-tickets/tickets.html',
      controller: 'TicketsController',
      controllerAs: 'tickets'
    })
    .state('payment', {
      url: '/payment',
      templateUrl: 'app/pages/payment/payment.html',
      controller: 'PaymentController',
      controllerAs: 'payment'
    });

    $locationProvider.html5Mode(true);
  }

})();

/* global moment:false */
(function() {
  'use strict';

  angular
    .module('tnsp')
    .constant('moment', moment)
    .constant('DATE_FORMAT','DD/MM/YYYY')
    .constant('DATE_ISO_FORMAT','YYYY-MM-DD')
    .constant('DATE_PICKER_FORMAT','MM/dd/yyyy')
    .constant('DATE_TIME_FORMAT', 'h:mm A')
    .constant('ONLY_NUMBERS_PATTERN',/^\d+$/)
    .constant('PAGINATION_CONFIG', {allowedRanges:[10, 15, 25, 50],maxPaginationItems:5})
    .constant('CIVIL_STATUS', [{id:1,name:'Soltero'}, {id:2,name:'Casado'}, {id:3,name:'Divorciado'}, {id:4,name:'Viudo'}])
    .constant('PAYMENT_TYPES', [{id:1,name:'Efectivo'}, {id:2,name:'Tarjeta'}, {id:3,name:'Agencia'}, {id:4, name:'Cortesia'}])
    .constant('LUGGAGE_PAYMENT_TYPES', [{id:1,name:'Efectivo'}, {id:2,name:'Tarjeta'}])
    .constant('GENRES', [{id:'M',name:'Masculino'}, {id:'F',name:'Femenino'}])
    .constant('WEEKDAYS', [{id:1,name:'Lunes'}, {id:2,name:'Martes'}, {id:3,name:'Miercoles'}, {id:4,name:'Jueves'}, {id:5,name:'Viernes'}, {id:6,name:'Sábado'}, {id:7,name:'Domingo'}])
    .constant('MONTHS', [{id:1, name:'Enero'}, {id:2, name:'Febrero'}, {id:3, name:'Marzo'}, {id:4, name:'Abril'}, {id:5, name:'Mayo'}, {id:4, name:'Junio'}, {id:1, name:'Julio'}, {id:8, name:'Agosto'}, {id:9, name:'Setiembre'}, {id:10, name:'Octubre'}, {id:11, name:'Noviembre'}, {id:12, name:'Diciembre'}])
    .constant('HEADER_MENU', [
      {
        text:'Inicio',
        title:'Inicio',
        isExternalLink: false,
        routerState:'/'
      },
      {
        text:'Transnica.com',
        title:'Transnica.com',
        isExternalLink: true,
        url: 'http://transnica.com/'
      }
    ])
    .constant('HEADER_SECONDARY_MENU', [
      {
        text:'Quienes somos',
        title:'Quienes somos',
        isExternalLink: true,
        url:'http://transnica.com/new/quienes-somos/'
      },
      {
        text:'Contáctenos',
        title:'Contáctenos',
        isExternalLink: true,
        url: 'mailto:info@transnica.com'
      },
      {
        text:'(506) 4404-0500',
        title:'(506) 4404-0500',
        isExternalLink: true
      }
    ])
    .constant('SOCIAL_MENU', [
      {
        text:'Facebook',
        title:'Facebook',
        classes: 'fa fa-facebook',
        url: 'http://facebook.com/transnica',
      },
      {
        text:'Twitter',
        title:'Twitter',
        classes: 'fa fa-twitter',
        url: 'http://twitter.com/'
      }
    ]);

})();

(function() {
  'use strict';

  angular
    .module('tnsp')
    .config(config);

  /** @ngInject */
  function config($logProvider, toastrConfig, $httpProvider) {
    // Enable log
    $logProvider.debugEnabled(true);

    // HTTP Interceptor
    $httpProvider.interceptors.push('authHttpResponseInterceptor');

    // Set Toastr options
    toastrConfig.allowHtml = true;
    toastrConfig.timeOut = 8000;
    toastrConfig.positionClass = 'toast-top-right';
    toastrConfig.progressBar = true;
    toastrConfig.closeButton = true;
  }

})();

angular.module("tnsp").run(["$templateCache", function($templateCache) {$templateCache.put("app/components/footer/footer.html","<footer class=container-fluid><div class=\"row max-width-content\"><div class=col-xs-12><p>Designed By: crpassion</p></div></div></footer>");
$templateCache.put("app/components/header/header.html","<header class=container-fluid><div class=row><div class=\"col-xs-12 no-padding\"><nav class=\"navbar navbar-static-top\"><div class=\"container no-padding\"><div class=col-xs-12><div class=navbar-header><a class=navbar-brand href=https://transnica.com target=_blank title=TransNica><img src=assets/images/logo-transnica.png alt=TransNica class=img-responsive> </a><button type=button class=navbar-toggle data-toggle=collapse data-target=#bs-mobile-navbar-collapse><span class=sr-only>Toggle navigation</span> <span class=icon-bar></span> <span class=icon-bar></span> <span class=icon-bar></span></button></div><div class=\"wrapper-menus hidden-xs\"><div class=sub-menu ng-show=\"header.secondaryMenu.length > 0\"><div class=\"row max-width-content\"><div><ul class=\"nav navbar-nav\"><li ng-repeat=\"item in header.secondaryMenu\"><a ng-if=!item.isExternalLink ui-sref={{item.routerState}} title={{item.title}} ui-sref-active=active><i class=\"fa fa-angle-right\" aria-hidden=true></i>{{item.text}}</a> <a ng-if=item.isExternalLink href={{item.url}} title={{item.title}} ui-sref-active=active><i class=\"fa fa-angle-right\" aria-hidden=true></i>{{item.text}}</a></li></ul></div></div></div><div class=main-menu ng-show=\"header.menu.length > 0\"><div class=\"row max-width-content\"><ul class=\"nav navbar-nav\"><li ng-repeat=\"item in header.menu\"><a ng-if=!item.isExternalLink ui-sref={{item.routerState}} title={{item.title}} ui-sref-active=active>{{item.text}}</a> <a ng-if=item.isExternalLink href={{item.url}} target=_blank title={{item.title}}>{{item.text}}</a></li></ul></div></div><div class=social-menu ng-show=\"header.socialMenu.length > 0\"><div class=\"row max-width-content\"><div class=col-xs-12><ul class=\"nav navbar-nav\"><li ng-repeat=\"item in header.socialMenu\"><a href={{item.url}} target=_blank title={{item.title}}><i class={{item.classes}} aria-hidden=true></i></a></li></ul></div></div></div></div><div class=\"collapse navbar-collapse hidden-lg hidden-md\" id=bs-mobile-navbar-collapse><ul class=\"nav navbar-nav mobile-nav hidden-lg hidden-md hidden-sm\"><li ng-repeat=\"item in header.menu\"><a ng-if=!item.isExternalLink ui-sref={{item.routerState}} title={{item.title}} ui-sref-active=active>{{item.text}}</a> <a ng-if=item.isExternalLink href={{item.url}} target=_blank title={{item.title}}>{{item.text}}</a></li></ul></div><!-- /.navbar-collapse --></div></div></nav></div></div></header>");
$templateCache.put("app/components/loading-overlay/loading-overlay.html","<div class=tnsp-overlay><img src=assets/images/loading.gif alt=loading></div>");
$templateCache.put("app/components/modal-client-form/modal-client-form.html","<div class=\"modal fade\" id=modalClientForm tabindex=-1 role=dialog aria-labelledby=modalClientForm><div class=modal-dialog role=document><div class=modal-content><form id=clientForm name=clientForm ng-submit=mClientForm.submitProcess(clientForm) novalidate><div class=modal-header><button type=button class=close data-dismiss=modal aria-label=Close><span aria-hidden=true>&times;</span></button><h4 class=modal-title><span ng-show=\"mClientForm.type === \'create\'\">Crear</span> <span ng-show=\"mClientForm.type === \'edit\'\">Editar</span> Cliente</h4></div><div class=modal-body><div class=row><div class=col-xs-6><div class=form-group><label for=FirstName>Nombre</label><input type=text name=FirstName id=FirstName class=form-control ng-model=mClientForm.client.firstName required><div class=error ng-messages=clientForm.FirstName.$error ng-show=mClientForm.submitAttempt><p ng-message=required>El Nombre es requerido</p></div></div></div><div class=col-xs-6><div class=form-group><label for=LastName>Apellido</label><input type=text name=LastName id=LastName class=form-control ng-model=mClientForm.client.lastName required><div class=error ng-messages=clientForm.LastName.$error ng-show=mClientForm.submitAttempt><p ng-message=required>El Apellido es requerido</p></div></div></div></div><div class=row><div class=col-xs-6><div class=form-group><label for=LastName2>Segundo Apellido</label><input type=text name=LastName2 id=LastName2 class=form-control ng-model=mClientForm.client.lastName2 required><div class=error ng-messages=clientForm.LastName2.$error ng-show=mClientForm.submitAttempt><p ng-message=required>El Segundo Apellido es requerido</p></div></div></div><div class=col-xs-6><div class=form-group><label>Genero</label><div><div class=\"radio radio-inline\" ng-repeat=\"genre in mClientForm.genres\"><input type=radio name=genre id=genre{{$index}} ng-value=genre.id ng-model=mClientForm.client.genre required><label for=genre{{$index}}>{{genre.name}}</label></div></div><div class=error ng-messages=clientForm.genre.$error ng-show=mClientForm.submitAttempt><p ng-message=required>El Genero es requerido</p></div></div></div></div><div class=row><div class=col-xs-6><div class=form-group><label for=IdentificationType>Tipo de Identificación</label><select name=IdentificationType id=IdentificationType class=form-control ng-model=mClientForm.client.identificationType.id ng-options=\"it.id as it.name for it in mClientForm.identificationTypes\" required><option value=\"\">Tipo de Identificación</option></select><div class=error ng-messages=clientForm.IdentificationType.$error ng-show=mClientForm.submitAttempt><p ng-message=required>El Tipo de Identificación es requerida</p></div></div></div><div class=col-xs-6><div class=form-group><label for=ClientIdentification>Identificación</label><input type=text name=ClientIdentification id=ClientIdentification class=form-control ng-model=mClientForm.client.identification required><div class=error ng-messages=clientForm.ClientIdentification.$error ng-show=mClientForm.submitAttempt><p ng-message=required>La Identificación es requerida</p></div></div></div></div><div class=row><div class=col-xs-6><div class=form-group><label for=IdentificationExpiration>Vencimiento de Identificación</label><p class=input-group><input type=text name=IdentificationExpiration id=IdentificationExpiration class=form-control uib-datepicker-popup=\"{{\'dd/MM/yyyy\'}}\" ng-model=mClientForm.client.identificationExpirationUI is-open=mClientForm.showIECalendar alt-input-formats=\"[\'DD/MM/YYYY\']\" ng-required=true> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=mClientForm.openIECalendar()><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p><div class=error ng-messages=clientForm.IdentificationExpiration.$error ng-show=mClientForm.submitAttempt><p ng-message=required>El Vencimiento de Identificación es requerido</p></div></div></div><div class=col-xs-6><div class=form-group><label for=birthdate>Fecha de Nacimiento</label><p class=input-group><input type=text name=birthdate id=birthdate class=form-control uib-datepicker-popup=\"{{\'dd/MM/yyyy\'}}\" ng-model=mClientForm.client.birthdateUI is-open=mClientForm.showBDCalendar alt-input-formats=\"[\'DD/MM/YYYY\']\" ng-required=true> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=mClientForm.openBDCalendar()><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p><div class=error ng-messages=clientForm.birthdate.$error ng-show=mClientForm.submitAttempt><p ng-message=required>La Fecha de nacimiento es requerida</p></div></div></div></div><div class=row><div class=col-xs-6><div class=form-group><label for=civilStatus>Estado Civil</label><select name=civilStatus id=civilStatus class=form-control ng-options=\"cs.name as cs.name for cs in mClientForm.civilStatues\" ng-model=mClientForm.client.civilStatus required><option value=\"\">Estado Civil</option></select><div class=error ng-messages=clientForm.civilStatus.$error ng-show=mClientForm.submitAttempt><p ng-message=required>El estado civil es requerido</p></div></div></div><div class=col-xs-6><div class=form-group><label for=Email>Correo Electrónico</label><input type=email name=Email id=Email class=form-control ng-model=mClientForm.client.email required><div class=error ng-messages=clientForm.Email.$error ng-show=mClientForm.submitAttempt><p ng-message=required>El correo electrónico es requerido</p><p ng-message=email>Correo electrónico invalido</p></div></div></div></div><div class=row><div class=col-xs-6><div class=form-group><div class=form-group><label>País de origen (Nacionalidad)</label><select name=Nationality id=Nationality class=form-control ng-model=mClientForm.client.nationality required ng-options=\"na.name as na.name for na in mClientForm.nationalities\"><option value=\"\">Nacionalidad</option></select><div class=error ng-messages=clientForm.Nationality.$error ng-show=mClientForm.submitAttempt><p ng-message=required>La Nacionalidad es requerida</p></div></div></div></div><div class=col-xs-6><div class=form-group><label for=Profession>Profesión</label><input type=text name=Profession id=Profession class=form-control ng-model=mClientForm.client.profession required><div class=error ng-messages=clientForm.Profession.$error ng-show=mClientForm.submitAttempt><p ng-message=required>La Profesión es requerida</p></div></div></div></div><div class=row><div class=col-xs-6><div class=form-group><label>Teléfono</label><input type=text name=Phone id=Phone class=form-control ng-model=mClientForm.client.phone required><div class=error ng-messages=clientForm.Phone.$error ng-show=mClientForm.submitAttempt><p ng-message=required>El Teléfono es requerido</p></div></div></div></div></div><div class=modal-footer><button type=button class=\"btn btn-default\" data-dismiss=modal>Cancelar</button> <button type=submit class=\"btn btn-primary\">Guardar</button></div></form></div></div></div>");
$templateCache.put("app/components/modal-print-ticket-invoice/modal-print-ticket-invoice.html","<div class=\"modal fade\" id=modalTicketInvoice tabindex=-1 role=dialog aria-labelledby=modalTicketInvoice><div class=modal-dialog role=document><div class=modal-content><div class=modal-header><button type=button class=close data-dismiss=modal aria-label=Close><span aria-hidden=true>&times;</span></button><h4 class=modal-title>Confirmación de boleto</h4></div><div class=modal-body><div class=\"row ticket-print\"><div id=printableArea class=col-xs-12><div class=ticket-container ng-repeat=\"invoice in mTicketInvoice.invoices\"><div class=row><div class=\"col-xs-12 text-center\"><h3 class=text-uppercase>TRANSNICA</h3><div class=row><div class=\"col-xs-6 text-left\"><h4>Transacción:</h4></div><div class=\"col-xs-6 text-right\"><h4>{{mTicketInvoice.transactionNumber}}</h4></div></div></div><div class=\"col-xs-12 text-center\"><hr><h4>Boleto</h4><hr><div class=row><div class=\"col-xs-6 text-left\"><h4>Boleto:</h4></div><div class=\"col-xs-6 text-right\"><h4>{{invoice.invoiceNumber}}</h4></div></div><div class=row><div class=\"col-xs-3 text-left\"><b>Ruta:</b></div><div class=\"col-xs-9 text-right\"><p>{{invoice.route}}</p></div></div><div class=row><div class=\"col-xs-5 text-left\"><b>Fecha:</b></div><div class=\"col-xs-7 text-right\"><p>{{invoice.date | amDateFormat:mTicketInvoice.dateFormat}}</p></div></div><div class=row><div class=\"col-xs-5 text-left\"><b>Hora:</b></div><div class=\"col-xs-7 text-right\"><p>{{invoice.time}}</p></div></div><div class=row><div class=\"col-xs-5 text-left\"><b>Compra:</b></div><div class=\"col-xs-7 text-right\"><p>En Linea</p></div></div><hr><div class=row><div class=\"col-xs-5 text-left\"><b>Abordaje:</b></div><div class=\"col-xs-7 text-right\"><p ng-show=invoice.boarding>{{invoice.boarding}}</p><p ng-show=!invoice.boarding>Estación Central</p></div></div><div class=row><div class=\"col-xs-5 text-left\"><b>Ident.:</b></div><div class=\"col-xs-7 text-right\"><p>{{invoice.identification}}</p></div></div><div class=row><div class=\"col-xs-5 text-left\"><b>Cliente:</b></div><div class=\"col-xs-7 text-right\"><p>{{invoice.client}}</p></div></div><div class=row><div class=\"col-xs-5 text-left\"><b>Nac.:</b></div><div class=\"col-xs-7 text-right\"><p>{{invoice.nationality}}</p></div></div><hr><div class=row><div class=\"col-xs-5 text-left\"><h4>Asiento:</h4></div><div class=\"col-xs-7 text-right\"><h4>{{invoice.seatNumber}}</h4></div></div><hr><!--<div class=\"row\">\n                    <div class=\"col-xs-7 text-left\">\n                      <b>Venta Grabada:</b>\n                    </div>\n                    <div class=\"col-xs-5 text-right\">\n                      <p>${{invoice.sold}}</p>\n                    </div>\n                  </div>\n                  <div class=\"row\">\n                    <div class=\"col-xs-6 text-left\">\n                      <b>IMP. {{invoice.terminal.country.taxName}}</b>\n                    </div>\n                    <div class=\"col-xs-6 text-right\">\n                      <p>${{invoice.tax}}</p>\n                    </div>\n                  </div>\n                  <div class=\"row\">\n                    <div class=\"col-xs-6 text-left\">\n                      <b>Descuento:</b>\n                    </div>\n                    <div class=\"col-xs-6 text-right\">\n                      <p>{{invoice.discount}}</p>\n                    </div>\n                  </div>--><div class=row><div class=\"col-xs-6 text-left\"><b>Total:</b></div><div class=\"col-xs-6 text-right\"><p><b>${{invoice.rate}}</b></p></div></div><div class=row><div class=\"col-xs-12 text-left\"><b>Impuestos Incluidos</b></div></div><hr><div class=row><div class=\"col-xs-12 text-center\"><small>{{mTicketInvoice.now | amDateFormat:\'DD/MM/YYYY h:mm A\'}}</small></div></div></div></div></div></div><iframe id=printableAreaFrame name=printableAreaFrame style=display:none></iframe></div></div><div class=modal-footer><!--<button type=\"button\" class=\"btn btn-secondary\" ng-click=\"mTicketInvoice.sms()\">SMS</button>--> <button type=button class=\"btn btn-primary\" ng-click=mTicketInvoice.print() ladda=mTicketInvoice.loading>Imprimir</button><!--<button type=\"button\" class=\"btn btn-primary\" ng-click=\"mTicketInvoice.print()\">Imprimir y SMS</button>--></div></div></div></div>");
$templateCache.put("app/components/modal-seats-form/modal-seats-form.html","<div class=\"modal fade\" id=modalSeatsForm ng-class=\"{\'modal-seats-lg\': mSeatsForm.tickets.newTicket.returnRoute && mSeatsForm.tickets.newTicket.route.transfer}\" tabindex=-1 role=dialog aria-labelledby=modalSeatsForm><div class=modal-dialog role=document><div class=modal-content><form id=seatsForm name=seatsForm ng-submit=mSeatsForm.submitProcess(seatsForm) novalidate><div class=modal-header><button type=button class=close data-dismiss=modal aria-label=Close><span aria-hidden=true>&times;</span></button><h4 class=modal-title>Seleccione {{mSeatsForm.tickets.newticket.clients.length}} asiento(s) por ruta</h4></div><div class=modal-body><div class=row><div class=col-xs-12><div class=row><div ng-class=\"{\'col-xs-6\': mSeatsForm.tickets.newTicket.returnRoute && mSeatsForm.tickets.newTicket.route.transfer, \'col-xs-12\': !mSeatsForm.tickets.newTicket.returnRoute && !mSeatsForm.tickets.newTicket.route.transfer}\"><h5>Ida <b ng-show=!mSeatsForm.tickets.newTicket.route.transfer>({{mSeatsForm.tickets.newTicket.route.name}})</b> <b ng-show=mSeatsForm.tickets.newTicket.route.transfer>({{mSeatsForm.tickets.newTicket.route.subRoutes[0].name}})</b></h5><div ng-repeat=\"seat in mSeatsForm.tickets.allSeats\" class=seats-container ng-if=\"$index % 4 === 0\"><div ng-if=\"$index % 4 === 0\" ng-init=\"group = mSeatsForm.tickets.allSeats.slice($index, $index + 4)\" class=seats-group><button type=button class=\"btn btn-clear btn-seat\" ng-repeat=\"seatItem in group\" ng-click=mSeatsForm.tickets.toggleSeatSelection(seatItem) ng-class=\"{occupied:seatItem.isOccupied, selected:seatItem.selected, \'btn-seat-window\': $index==2}\" ng-disabled=\"seatItem.isOccupied || (mSeatsForm.tickets.selectedSeat.length >= mSeatsForm.tickets.newticket.clients.length && !seatItem.selected)\">{{seatItem.seatNumber}}</button></div></div></div><div ng-class=\"{\'col-xs-6\': mSeatsForm.tickets.newTicket.returnRoute && mSeatsForm.tickets.newTicket.route.transfer, \'col-xs-12\': !mSeatsForm.tickets.newTicket.returnRoute && !mSeatsForm.tickets.newTicket.route.transfer}\" ng-show=\"mSeatsForm.tickets.allReturnSeats.length > 0\"><h5>Vuelta <b>({{mSeatsForm.tickets.newTicket.returnRoute.name}})</b></h5><div ng-repeat=\"seat in mSeatsForm.tickets.allReturnSeats\" class=seats-container ng-if=\"$index % 4 === 0\"><div ng-if=\"$index % 4 === 0\" ng-init=\"group = mSeatsForm.tickets.allReturnSeats.slice($index, $index + 4)\" class=seats-group><button type=button class=\"btn btn-clear btn-seat\" ng-repeat=\"seatItem in group\" ng-click=mSeatsForm.tickets.toggleReturnSeatSelection(seatItem) ng-class=\"{occupied:seatItem.isOccupied, selected:seatItem.selected, \'btn-seat-window\': $index==2}\" ng-disabled=\"seatItem.isOccupied || (mSeatsForm.tickets.selectedReturnSeat.length >= mSeatsForm.tickets.newticket.clients.length && !seatItem.selected)\">{{seatItem.seatNumber}}</button></div></div></div></div><div class=error ng-show=mSeatsForm.tickets.submitAttemptStep3><p ng-show=\"mSeatsForm.tickets.selectedSeat.length !== mSeatsForm.tickets.newticket.clients.length\">Debe seleccionar la misma cantidad de asientos como de clientes en el paso anterior</p><p ng-show=\"mSeatsForm.tickets.newticket.typeOfTrip == 2 && mSeatsForm.tickets.selectedReturnSeat.length !== mSeatsForm.tickets.newticket.clients.length\">Debe seleccionar la misma cantidad de asientos como de clientes en el paso anterior para la ruta de vuelta</p></div></div><!-- TRANSFER--><div class=col-xs-12><div class=row ng-if=\"mSeatsForm.tickets.newTicket.route.transfer || mSeatsForm.tickets.newTicket.returnRoute.transfer\"><div ng-class=\"{\'col-xs-6\': mSeatsForm.tickets.newTicket.returnRoute && mSeatsForm.tickets.newTicket.route.transfer, \'col-xs-12\': !mSeatsForm.tickets.newTicket.returnRoute && !mSeatsForm.tickets.newTicket.route.transfer}\"><h5>Ida Conexión <b>({{mSeatsForm.tickets.newTicket.route.subRoutes[1].name}})</b></h5><div ng-repeat=\"seat in mSeatsForm.tickets.allSeatsT\" class=seats-container><div ng-if=\"$index % 4 === 0\" ng-init=\"group = mSeatsForm.tickets.allSeatsT.slice($index, $index + 4)\" class=seats-group><button type=button class=\"btn btn-clear btn-seat\" ng-repeat=\"seatItem in group\" ng-click=mSeatsForm.tickets.toggleSeatSelectionT(seatItem) ng-class=\"{occupied:seatItem.isOccupied, selected:seatItem.selected, \'btn-seat-window\': $index==2}\" ng-disabled=\"seatItem.isOccupied || (mSeatsForm.tickets.selectedSeatT.length >= mSeatsForm.tickets.newticket.clients.length && !seatItem.selected)\">{{seatItem.seatNumber}}</button></div></div></div><div ng-class=\"{\'col-xs-6\': mSeatsForm.tickets.newTicket.returnRoute && mSeatsForm.tickets.newTicket.route.transfer, \'col-xs-12\': !mSeatsForm.tickets.newTicket.returnRoute && !mSeatsForm.tickets.newTicket.route.transfer}\" ng-show=mSeatsForm.tickets.newTicket.returnRoute.transfer><h5>Vuelta <b>({{mSeatsForm.tickets.newTicket.returnRoute.subRoutes[1].name}})</b></h5><div ng-repeat=\"seat in mSeatsForm.tickets.allReturnSeatsT\" class=seats-container><div ng-if=\"$index % 4 === 0\" ng-init=\"group = mSeatsForm.tickets.allReturnSeatsT.slice($index, $index + 4)\" class=seats-group><button type=button class=\"btn btn-clear btn-seat\" ng-repeat=\"seatItem in group\" ng-click=mSeatsForm.tickets.toggleReturnSeatSelectionT(seatItem) ng-class=\"{occupied:seatItem.isOccupied, selected:seatItem.selected}\" ng-disabled=\"seatItem.isOccupied || (mSeatsForm.tickets.selectedReturnSeatT.length >= mSeatsForm.tickets.newticket.clients.length && !seatItem.selected)\">{{seatItem.seatNumber}}</button></div></div></div></div><div class=error ng-show=mSeatsForm.tickets.submitAttemptStep3><p ng-show=\"mSeatsForm.tickets.selectedSeatT.length !== mSeatsForm.tickets.newticket.clients.length\">Debe seleccionar la misma cantidad de asientos como de clientes en el paso anterior</p><p ng-show=\"(mSeatsForm.tickets.newticket.typeOfTrip == 2 && mSeatsForm.tickets.selectedReturnSeatT.length !== mSeatsForm.tickets.newticket.clients.length)\">Debe seleccionar la misma cantidad de asientos como de clientes en el paso anterior para la ruta de vuelta</p></div></div></div></div><div class=modal-footer><button type=button class=\"btn btn-default\" data-dismiss=modal>Cancelar</button> <button type=submit class=\"btn btn-primary\">Guardar</button></div></form></div></div></div>");
$templateCache.put("app/components/modal-terms/modal-terms.html","<div class=\"modal fade\" id=modalTermsAndConditions tabindex=-1 role=dialog aria-labelledby=modalTermsAndConditions><div class=\"modal-dialog modal-lg\" role=document><div class=modal-content><div class=modal-header><button type=button class=close data-dismiss=modal aria-label=Close><span aria-hidden=true>&times;</span></button><h4 class=modal-title>Términos y Condiciones de Viaje</h4></div><div class=modal-body><ol><li>Este boleto de viaje es intransferible y no reembolsable.</li><li>Todo tiquete de regreso debe confirmarse o modificarse con cinco (5) días de antelación. Una vez confirmada o modificada la fecha de viaje todo cambio se penaliza con USD $5</li><li>Este tiquete no tiene fecha de vencimiento. Sin embargo deberá cancelar la diferencia del valor al momento de utilizarlo en caso de que exista modificación en precio con respecto a la fecha de emisión.</li><li><b>Solo se permite 35 Kg de equipaje por persona si sobrepasa esa cantidad deberá cancelar la tarifa estipulada por cada Kilo Adicional.</b></li><li>La empresa considera carga todo aquello que no sea enseres personales contemplados en el punto anterior, lo cual deberá pagar el importe por el transporte del artículo en la oficina correspondiente (Sujeto a espacio).</li><li>No se permite cargar muebles o electrodomésticos cuyo tamaño exceda la razonabilidad, la empresa se reserva el derecho de cobrar excedente por peso o volumen.</li><li>No se permite viajar con animales (Ley de Tránsito).</li><li>Todo asiento ocupado debe cancelarse. En el caso de infantes no pagaran transporte cuando viaje en brazos y hasta 3 años.</li><li>Todo pasajero debe viajar con sus documentos migratorios al día y en orden, según la regulación Migratoria del país de destino.</li><li>La empresa no tendrá responsabilidad con aquellos pasajeros que sufran atrasos en puestos migratorios ni de aduanas por aforo de su carga o trámites migratorios, por respeto a los demás pasajeros, el conductor no puede esperar a pasajeros.</li><li>El pasajero debe presentarse a la terminal 45 minutos antes obligatoriamente para realizar el debido trámite (chequeo de tiquete) para abordar el autobús, el conductor no espera a pasajeros con llegadas tardías, este sería eliminado de la lista y es prohibido intentar abordar el autobús en carretera sin estar en la lista correspondiente.</li><li>El pasajero debe ocupar el asiento indicado en su boleto.</li><li>El autobús se detendrá únicamente en las paradas autorizadas.</li><li>Todo pasajero debe mantener las mejores normas de conducta durante el viaje, no se permite pasajeros en estado de embriaguez, fumar, consumir drogas o cualquier otra actitud que atente contra los demás pasajeros, la empresa se reserva el derecho en excluir pasajeros que incumplan esta condición. (Ley de tránsito. Reglamento de transporte)</li><li>La empresa no se hace responsable por pérdidas de equipaje de mano, igualmente debe estar pendiente del trámite de su equipaje en frontera, cada pasajero tiene la obligación de velar por sus pertenencias en la Aduana, la empresa no responde por pérdidas en esta zona.</li></ol></div><div class=modal-footer><button type=button class=\"btn btn-primary\" data-dismiss=modal>Aceptar</button></div></div><!-- /.modal-content --></div></div>");
$templateCache.put("app/components/sidebar/sidebar.html","<aside><ul class=general-items><li ng-repeat=\"item in sidebar.sideBarItems\"><a ui-sref={{item.routerState}} title={{item.title}} ui-sref-active=active><i class=\"fa {{item.icon}}\"></i> {{item.text}}</a></li></ul><hr><h2 ng-if=sidebar.title>{{sidebar.title}}</h2><ul><li ng-repeat=\"item in sidebar.items\"><a ui-sref={{item.routerState}} title={{item.title}} ui-sref-active=active><i class=\"fa {{item.icon}}\"></i> {{item.text}}</a></li></ul></aside>");
$templateCache.put("app/pages/payment/payment.html","<div class=container-fluid><div class=\"row payment\"><div class=\"col-xs-12 col-md-8 col-md-offset-2\"><form id=paymentForm action=https://credomatic.compassmerchantsolutions.com/api/transact.php class=m-top-20 method=post name=CredomaticPost><div class=row><div class=col-xs-12><div class=form-group><input id=hash class=form-control type=hidden name=hash ng-model=payment.formFields.hash ng-value=payment.formFields.hash> <input id=time class=form-control type=hidden name=time ng-model=payment.formFields.time ng-value=payment.formFields.time> <input id=type class=form-control type=hidden name=type ng-model=payment.formFields.type ng-value=payment.formFields.type> <input id=keyId class=form-control type=hidden name=key_id ng-model=payment.formFields.keyId ng-value=payment.formFields.keyId> <input id=amount class=form-control type=hidden name=amount ng-model=payment.formFields.amount ng-value=payment.formFields.amount> <input id=orderId class=form-control type=hidden name=orderid ng-model=payment.formFields.orderId ng-value=payment.formFields.orderId> <input id=redirect class=form-control type=hidden name=redirect ng-model=payment.formFields.redirect ng-value=payment.formFields.redirect> <input id=processorId class=form-control type=hidden name=processor_id ng-model=payment.formFields.processorId ng-value=payment.formFields.processorId></div></div></div><div class=row><div class=\"col-xs-12 col-md-6\"><div class=form-group><label for=ccnumber>Número de Tarjeta</label><input id=ccnumber class=form-control type=text name=ccnumber ng-model=payment.formFields.ccnumber ng-value=payment.formFields.ccnumber></div></div><div class=\"col-xs-12 col-md-3\"><div class=form-group><label for=ccexp>Fecha de Expiración</label><input id=ccexp class=form-control type=text name=ccexp ng-model=payment.formFields.ccexp ng-value=payment.formFields.ccexp placeholder=mm/aa></div></div><div class=\"col-xs-12 col-md-3\"><div class=form-group><label for=cvv>CVV</label><input id=cvv class=form-control type=text name=cvv ng-model=payment.formFields.cvv ng-value=payment.formFields.cvv></div></div></div><div class=row><div class=\"col-xs-12 text-center\"><strong>Monto: </strong>{{payment.formFields.amount}}</div></div><div class=row><div class=\"col-xs-12 text-center m-top-20\"><button class=\"btn btn-primary\" type=submit>Pagar</button></div></div></form></div></div></div>");
$templateCache.put("app/pages/payment-result/payment-result.html","<div class=container-fluid><div class=\"row payment\"><div class=\"col-xs-12 col-md-8 col-md-offset-2\"><ul><li><b>Response: </b>{{paymentResult.response.response}}</li><li><b>Response Text: </b>{{paymentResult.response.responsetext}}</li><li><b>Response Code: </b>{{paymentResult.response.response_code}}</li><li><b>Transaction Id: </b>{{paymentResult.response.transactionid}}</li></ul><button class=\"btn btn-primary\" ng-click=paymentResult.completePayment()>Terminar</button></div></div></div>");
$templateCache.put("app/pages/sales-tickets/tickets.html","<div class=imageContainer ng-class=tickets.layoutClass></div><div class=\"container-fluid tickets scrollable relative-pos\" bs-loading-overlay bs-loading-overlay-reference-id=ticket-payment><wizard class=\"wizard container\" ng-class=tickets.wizardClass name=ticket-wizard><wz-step wz-title=Búsqueda><form id=TicketStep1Form name=TicketStep1Form ng-submit=tickets.goToItinerary(TicketStep1Form) novalidate><div class=row><div class=\"col-xs-10 col-xs-offset-1\"><!--First Way --><div class=row ng-if=tickets.newTicket.route.transfer><div class=col-xs-12><p class=transfer-msg>Recuerde que para hacer transbordo el mismo día, deberá viajar en el primer bus u horario de la ruta inicial.</p></div></div><div class=row><div class=\"col-xs-12 col-sm-6\"><div class=form-group><label for=Route>Tipo de viaje:</label><div class=\"form-inline form-group wrapperTypeOfTrip\"><div class=radio><input type=radio name=typeOfTrip id=Ida ng-model=tickets.newticket.typeOfTrip ng-change=tickets.changeTypeOfTrip(1) value=1><label for=Ida>Ida</label></div><div class=radio><input type=radio name=typeOfTrip id=twoWaysTrip ng-model=tickets.newticket.typeOfTrip ng-change=tickets.changeTypeOfTrip(2) value=2><label for=twoWaysTrip>Doble Vía</label></div><div class=radio><input type=radio name=typeOfTrip id=openTrip ng-model=tickets.newticket.typeOfTrip ng-change=tickets.changeTypeOfTrip(3) value=3><label for=openTrip>Abierto</label></div></div></div></div><div class=\"col-xs-12 col-sm-6\"><div class=form-group><label for=Route>Ruta:</label><select name=Route id=Route class=form-control ng-options=\"route as route.name for route in tickets.routesList\" ng-model=tickets.newTicket.route ng-change=tickets.loadSchedulesAvailable() required><option value=\"\">Ruta</option></select><span ng-if=tickets.newTicket.route.transfer>Primer viaje: {{tickets.newTicket.route.subRoutes[0].name}}</span><div class=error ng-show=tickets.submitAttemptStep1><p ng-show=TicketStep1Form.Route.$error.required>La ruta es requerida</p></div></div></div></div><div class=row><div class=\"col-xs-12 col-sm-4\"><div class=form-group><label for=OriginDate>Fecha:</label><p class=\"input-group m-bottom-0\"><input type=text name=OriginDate id=OriginDate class=form-control uib-datepicker-popup=\"{{\'dd/MM/yyyy\'}}\" ng-model=tickets.originDateUI is-open=tickets.showOriginCalendar alt-input-formats=\"[\'DD/MM/YYYY\']\" ng-required=\"tickets.newticket.typeOfTrip != 3\" ng-blur=tickets.loadSchedulesAvailable() ng-disabled=\"tickets.newticket.typeOfTrip ==3\" datepicker-options=tickets.dateConfig> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=tickets.openOriginDate() ng-disabled=\"tickets.newticket.typeOfTrip == 3\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p><div class=error ng-show=tickets.submitAttemptStep1><p ng-show=TicketStep1Form.OriginDate.$error.required>La fecha es requerida</p><p ng-show=TicketStep1Form.OriginDate.$error.date>Fecha Invalida</p></div></div></div><div class=\"col-xs-12 col-sm-4\"><div class=form-group><label for=BusType>Tipo de Servicio:</label><select name=BusType id=BusType class=form-control ng-options=\"busType.id as busType.name for busType in tickets.busClasses\" ng-model=tickets.newTicket.busType ng-change=tickets.loadSchedulesAvailable() ng-required=true><option value=\"\">Tipo de Servicio</option></select><div class=error ng-show=tickets.submitAttemptStep1><p ng-show=TicketStep1Form.BusType.$error.required>La tipo de servicio es requerido</p></div></div></div><div class=\"col-xs-12 col-sm-4\"><div class=form-group><label for=SchedulesAvailable>Horarios</label><select name=SchedulesAvailable id=SchedulesAvailable class=form-control ng-options=\"trip as trip.schedule.departureTime for trip in tickets.schedulesAvailable\" ng-model=tickets.newTicket.selectedTrip ng-change=tickets.generateSeats() ng-disabled=\"tickets.newticket.typeOfTrip == 3\" ng-required=\"tickets.newticket.typeOfTrip != 3\"><option value=\"\">Horarios</option></select><div class=error ng-show=tickets.submitAttemptStep1><p ng-show=TicketStep1Form.SchedulesAvailable.$error.required>El horario es requerido</p></div></div></div></div><div class=row><div class=col-xs-12><p class=\"transfer-msg text-right\" ng-if=tickets.noTrips>La Ruta y fecha seleccionada no tiene ningún horario disponible</p><p class=\"transfer-msg text-right\" ng-if=tickets.noSeats>La fecha y horario seleccionado no tiene ningún asiento disponible</p></div></div><!--First Way TRANSFER --><div class=row ng-if=tickets.newTicket.route.transfer><div class=col-xs-12><hr><span>TRANSBORDO EN:</span></div><div class=col-xs-4><div class=form-group><label for=RouteT>Ruta de transbordo:</label><select name=RouteT id=RouteT class=form-control ng-options=\"route.id as route.name for route in tickets.routesList\" ng-model=tickets.newTicket.route.subRoutes[1].id ng-change=tickets.loadSchedulesAvailableT() disabled><option value=\"\">Ruta</option></select></div></div></div><div class=row ng-if=tickets.newTicket.route.transfer><div class=col-xs-4><div class=form-group><label for=OriginDate>Fecha:</label><p class=\"input-group m-bottom-0\"><input type=text name=OriginDateT id=OriginDateT class=form-control uib-datepicker-popup=\"{{\'dd/MM/yyyy\'}}\" ng-model=tickets.originDateTUI is-open=tickets.showOriginTCalendar alt-input-formats=\"[\'DD/MM/YYYY\']\" ng-required=\"tickets.newticket.typeOfTrip != 3\" ng-blur=tickets.loadSchedulesAvailableT() ng-disabled=\"tickets.newticket.typeOfTrip ==3\" datepicker-options=tickets.dateConfig> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=\"tickets.showOriginTCalendar = true\" ng-disabled=\"tickets.newticket.typeOfTrip == 3\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p><div class=error ng-show=tickets.submitAttemptStep1><p ng-show=TicketStep1Form.OriginDateT.$error.required>La fecha es requerida</p><p ng-show=TicketStep1Form.OriginDateT.$error.date>Fecha Invalida</p></div></div></div><div class=col-xs-4><div class=form-group><label for=BusTypeT>Tipo de Bus:</label><select name=BusTypeT id=BusTypeT class=form-control ng-options=\"busType.id as busType.name for busType in tickets.busClasses\" ng-model=tickets.newTicket.busTypeT ng-change=tickets.loadSchedulesAvailableT() ng-required=true><option value=\"\">Tipo de Bus</option></select><div class=error ng-show=tickets.submitAttemptStep1><p ng-show=TicketStep1Form.BusTypeT.$error.required>La tipo de bus es requerido</p></div></div></div><div class=col-xs-4><div class=form-group><label for=SchedulesAvailableT>Horarios</label><select name=SchedulesAvailableT id=SchedulesAvailableT class=form-control ng-options=\"trip as trip.schedule.departureTime for trip in tickets.schedulesAvailableT\" ng-model=tickets.newTicket.selectedTripT ng-change=tickets.generateTSeats() ng-disabled=\"tickets.newticket.typeOfTrip == 3\" ng-required=\"tickets.newticket.typeOfTrip != 3\"><option value=\"\">Horarios</option></select><div class=error ng-show=tickets.submitAttemptStep1><p ng-show=TicketStep1Form.SchedulesAvailable.$error.required>El horario es requerido</p></div></div></div></div><!-- FINISH First Way TRANSFER --><!--Second Way --><div ng-show=\"tickets.newticket.typeOfTrip == 2\"><div class=row><hr><h4>Boleto de vuelta</h4></div><div class=row><div class=\"col-xs-12 col-sm-6\"><div class=form-group><label for=ReturnRoute>Ruta:</label><select name=ReturnRoute id=ReturnRoute class=form-control ng-options=\"route as route.name for route in tickets.routesList\" ng-model=tickets.newTicket.returnRoute ng-change=tickets.loadReturnSchedulesAvailable() ng-required=\"tickets.newticket.typeOfTrip == 2\" ng-disabled=\"tickets.newticket.typeOfTrip == 2 && tickets.disableReturnRoute\"><option value=\"\">Ruta</option></select><span ng-if=tickets.newTicket.returnRoute.transfer>{{tickets.newTicket.returnRoute.subRoutes[0].name}}</span><div class=error ng-show=tickets.submitAttemptStep1><p ng-show=TicketStep1Form.ReturnRoute.$error.required>La ruta es requerida</p></div></div></div></div><div class=row><div class=\"col-xs-12 col-sm-4\"><div class=form-group><label for=ReturnDate>Fecha:</label><p class=\"input-group m-bottom-0\"><input type=text name=ReturnDate id=ReturnDate class=form-control uib-datepicker-popup=\"{{\'dd/MM/yyyy\'}}\" ng-model=tickets.returnDateUI is-open=tickets.showReturnCalendar alt-input-formats=\"[\'DD/MM/YYYY\']\" ng-required=\"tickets.newticket.typeOfTrip == 2\" ng-blur=tickets.loadReturnSchedulesAvailable() ng-disabled=\"tickets.newticket.typeOfTrip ==3\" datepicker-options=tickets.dateConfig> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=tickets.openReturnDate() ng-disabled=\"tickets.newticket.typeOfTrip == 3\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p><div class=error ng-show=tickets.submitAttemptStep1><p ng-show=TicketStep1Form.ReturnDate.$error.required>La fecha es requerida</p><p ng-show=TicketStep1Form.ReturnDate.$error.date>Fecha Invalida</p></div></div></div><div class=\"col-xs-12 col-sm-4\"><div class=form-group><label for=ReturnBusType>Tipo de Servicio:</label><select name=ReturnBusType id=ReturnBusType class=form-control ng-options=\"busType.id as busType.name for busType in tickets.busClasses\" ng-model=tickets.newTicket.returnBusType ng-change=tickets.loadReturnSchedulesAvailable() ng-required=\"tickets.newticket.typeOfTrip == 2\"><option value=\"\">Tipo de Servicio</option></select><div class=error ng-show=tickets.submitAttemptStep1><p ng-show=TicketStep1Form.ReturnBusType.$error.required>La tipo de servicio es requerido</p></div></div></div><div class=\"col-xs-12 col-sm-4\"><div class=form-group><label for=ReturnSchedulesAvailable>Horarios</label><select name=ReturnSchedulesAvailable id=ReturnSchedulesAvailable class=form-control ng-options=\"trip as trip.schedule.departureTime for trip in tickets.returnSchedulesAvailable\" ng-model=tickets.newTicket.selectedReturnTrip ng-change=tickets.generateReturnSeats() ng-required=\"tickets.newticket.typeOfTrip == 2\"><option value=\"\">Horarios</option></select><div class=error ng-show=tickets.submitAttemptStep1><p ng-show=TicketStep1Form.ReturnSchedulesAvailable.$error.required>El horario es requerido</p></div></div></div></div><!--RETURN Way TRANSFER --><div class=row ng-if=tickets.newTicket.returnRoute.transfer><hr><div class=\"col-xs-12 col-md-6\"><div class=form-group><label for=ReturnRouteT>Ruta de transbordo:</label><select name=ReturnRouteT id=ReturnRouteT class=form-control ng-options=\"route.id as route.name for route in tickets.routesList\" ng-model=tickets.newTicket.returnRoute.subRoutes[1].id ng-change=tickets.loadReturnSchedulesAvailableT() disabled><option value=\"\">Ruta</option></select></div></div></div><div class=row ng-if=tickets.newTicket.returnRoute.transfer><div class=col-xs-4><div class=form-group><label for=ReturnDateT>Fecha:</label><p class=\"input-group m-bottom-0\"><input type=text name=ReturnDateT id=ReturnDateT class=form-control uib-datepicker-popup=\"{{\'dd/MM/yyyy\'}}\" ng-model=tickets.returnDateTUI is-open=tickets.showReturnTCalendar alt-input-formats=\"[\'DD/MM/YYYY\']\" ng-required=\"tickets.newticket.typeOfTrip != 3\" ng-blur=tickets.loadReturnSchedulesAvailableT() ng-disabled=\"tickets.newticket.typeOfTrip ==3\" datepicker-options=tickets.dateConfig> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=\"tickets.showReturnTCalendar = true\" ng-disabled=\"tickets.newticket.typeOfTrip == 3\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p><div class=error ng-show=tickets.submitAttemptStep1><p ng-show=TicketStep1Form.ReturnDateT.$error.required>La fecha es requerida</p><p ng-show=TicketStep1Form.ReturnDateT.$error.date>La fecha es requerida</p></div></div></div><div class=col-xs-4><div class=form-group><label for=ReturnBusTypeT>Tipo de Bus:</label><select name=ReturnBusTypeT id=ReturnBusTypeT class=form-control ng-options=\"busType.id as busType.name for busType in tickets.busClasses\" ng-model=tickets.newTicket.returnBusTypeT ng-change=tickets.loadReturnSchedulesAvailableT() ng-required=true><option value=\"\">Tipo de Bus</option></select><div class=error ng-show=tickets.submitAttemptStep1><p ng-show=TicketStep1Form.ReturnBusTypeT.$error.required>La tipo de bus es requerido</p></div></div></div><div class=col-xs-4><div class=form-group><label for=ReturnSchedulesAvailableT>Horarios</label><select name=ReturnSchedulesAvailableT id=ReturnSchedulesAvailableT class=form-control ng-options=\"trip as trip.schedule.departureTime for trip in tickets.returnSchedulesAvailableT\" ng-model=tickets.newTicket.selectedReturnTripT ng-change=tickets.generateReturnTSeats() ng-disabled=\"tickets.newticket.typeOfTrip == 3\" ng-required=\"tickets.newticket.typeOfTrip != 3\"><option value=\"\">Horarios</option></select><div class=error ng-show=tickets.submitAttemptStep1><p ng-show=TicketStep1Form.ReturnSchedulesAvailableT.$error.required>El horario es requerido</p></div></div></div></div></div><div class=row><div class=\"col-xs-12 text-center\"><input type=submit value=Buscar class=\"btn btn-primary\"></div></div></div></div></form></wz-step><wz-step wz-title=Itinerario><div class=\"row itinerario\"><div class=\"col-xs-12 wrapper-routes\"><div class=\"row departure p-bottom-10\"><div class=\"col-sm-3 hidden-xs\"><img ng-show=\"tickets.newTicket.busType==2\" src=assets/images/icon_fclass.png alt=\"Servicio Ejecutivo\" class=\"img-responsive pull-right executive-stamp\"></div><div class=col-sm-8><h3>BOLETO DE IDA</h3><div class=\"row route\" ng-if=!tickets.newTicket.route.transfer><div class=\"col-sm-4 col-xs-6 xs-mar-20 from\"><p class=time ng-show=\"tickets.newticket.typeOfTrip != 3\">{{tickets.newTicket.selectedTrip.schedule.departureTime}}</p><p class=time ng-show=\"tickets.newticket.typeOfTrip == 3\">Hora abierta</p><p class=date ng-show=\"tickets.newticket.typeOfTrip != 3\">{{tickets.newTicket.selectedTrip.date}}</p><p class=date ng-show=\"tickets.newticket.typeOfTrip == 3\">Fecha abierta</p><p class=city>{{tickets.newTicket.route.departure}}</p><p class=station>Estación central</p><i class=\"fa fa-arrow-right\" aria-hidden=true></i></div><div class=\"col-sm-4 col-xs-6 xs-mar-20\"><p class=time ng-show=\"tickets.newticket.typeOfTrip != 3\">{{tickets.newTicket.selectedTrip.schedule.arrivalTime}}</p><p class=time ng-show=\"tickets.newticket.typeOfTrip == 3\">Hora abierta</p><p class=date ng-show=\"tickets.newticket.typeOfTrip != 3\">{{tickets.newTicket.selectedTrip.date}}</p><p class=date ng-show=\"tickets.newticket.typeOfTrip == 3\">Fecha abierta</p><p class=city>{{tickets.newTicket.route.destiny}}</p><p class=station>Estación central</p></div><div class=\"col-sm-4 wrapper-price\"><span class=price ng-show=\"tickets.newticket.typeOfTrip != 3\"><span ng-if=!tickets.newTicket.route.transfer>${{tickets.newTicket.selectedTrip.schedule.routeRate.countryRates.CR}}</span> <span ng-if=tickets.newTicket.route.transfer>${{tickets.newTicket.priceWithTransfer}}</span> </span><span class=price id=PriceOpen name=PriceOpen ng-show=\"tickets.newticket.typeOfTrip == 3\">${{tickets.openRouteRate.countryRates.CR}}</span> <span class=gray-title>/ por persona</span> <img src=assets/images/icon_features.jpg alt=Servicios class=\"img-responsive features-icons\"></div></div><div class=\"row route\" ng-if=tickets.newTicket.route.transfer><div class=\"col-sm-4 col-xs-6 xs-mar-20 from\"><p class=time ng-show=\"tickets.newticket.typeOfTrip != 3\">{{tickets.newTicket.selectedTrip.schedule.departureTime}}</p><p class=time ng-show=\"tickets.newticket.typeOfTrip == 3\">Hora abierta</p><p class=date ng-show=\"tickets.newticket.typeOfTrip != 3\">{{tickets.newTicket.selectedTrip.date}}</p><p class=date ng-show=\"tickets.newticket.typeOfTrip == 3\">Fecha abierta</p><p class=city>{{tickets.newTicket.route.subRoutes[0].departure}}</p><p class=station>Estación central</p><i class=\"fa fa-arrow-right\" aria-hidden=true></i></div><div class=\"col-sm-4 col-xs-6 xs-mar-20\"><p class=time ng-show=\"tickets.newticket.typeOfTrip != 3\">{{tickets.newTicket.selectedTrip.schedule.arrivalTime}}</p><p class=time ng-show=\"tickets.newticket.typeOfTrip == 3\">Hora abierta</p><p class=date ng-show=\"tickets.newticket.typeOfTrip != 3\">{{tickets.newTicket.selectedTrip.date}}</p><p class=date ng-show=\"tickets.newticket.typeOfTrip == 3\">Fecha abierta</p><p class=city>{{tickets.newTicket.route.subRoutes[0].destiny}}</p><p class=station>Estación central</p></div><div class=\"col-sm-4 wrapper-price\" ng-show=\"tickets.newticket.typeOfTrip == 3\"><span class=price id=PriceOpen name=PriceOpen>${{tickets.openRouteRate.countryRates.CR}}</span> <span class=gray-title>/ por persona</span> <img src=assets/images/icon_features.jpg alt=Servicios class=\"img-responsive features-icons\"></div></div><div class=\"row route\" ng-if=tickets.newTicket.route.transfer><div class=\"col-sm-4 col-xs-6 xs-mar-20 from\"><p class=time ng-show=\"tickets.newticket.typeOfTrip != 3\">{{tickets.newTicket.selectedTripT.schedule.departureTime}}</p><p class=time ng-show=\"tickets.newticket.typeOfTrip == 3\">Hora abierta</p><p class=date ng-show=\"tickets.newticket.typeOfTrip != 3\">{{tickets.newTicket.selectedTripT.date}}</p><p class=date ng-show=\"tickets.newticket.typeOfTrip == 3\">Fecha abierta</p><p class=city>{{tickets.newTicket.route.subRoutes[1].departure}}</p><p class=station>Estación central</p><i class=\"fa fa-arrow-right\" aria-hidden=true></i></div><div class=\"col-sm-4 col-xs-6 xs-mar-20\"><p class=time ng-show=\"tickets.newticket.typeOfTrip != 3\">{{tickets.newTicket.selectedTripT.schedule.arrivalTime}}</p><p class=time ng-show=\"tickets.newticket.typeOfTrip == 3\">Hora abierta</p><p class=date ng-show=\"tickets.newticket.typeOfTrip != 3\">{{tickets.newTicket.selectedTripT.date}}</p><p class=date ng-show=\"tickets.newticket.typeOfTrip == 3\">Fecha abierta</p><p class=city>{{tickets.newTicket.route.subRoutes[1].destiny}}</p><p class=station>Estación central</p></div><div class=\"col-sm-4 wrapper-price\"><span class=price ng-show=\"tickets.newticket.typeOfTrip != 3\"><span ng-if=tickets.newTicket.route.transfer>${{tickets.newTicket.priceWithTransfer}}</span> </span><span class=price id=PriceOpen name=PriceOpen ng-show=\"tickets.newticket.typeOfTrip == 3\">${{tickets.openRouteRate.countryRates.CR}}</span> <span class=gray-title>/ por persona</span> <img src=assets/images/icon_features.jpg alt=Servicios class=\"img-responsive features-icons\"></div></div></div></div><div class=\"row return p-bottom-10\" ng-if=tickets.newTicket.selectedReturnTrip><div class=\"col-sm-3 hidden-xs\"><img ng-show=\"tickets.newTicket.returnBusType==2\" src=assets/images/icon_fclass.png alt=\"Servicio Ejecutivo\" class=\"img-responsive pull-right executive-stamp\"></div><div class=col-sm-8><h3>BOLETO DE VUELTA</h3><!--<div class=\"row route\">\n                <div class=\"col-sm-4 col-xs-6 from xs-mar-20\">\n                  <p class=\"time\">{{tickets.newTicket.selectedReturnTrip.schedule.departureTime}}</p>\n                  <p class=\"date\">{{tickets.newTicket.selectedReturnTrip.date}}</p>\n                  <p class=\"city\">{{tickets.newTicket.returnRoute.departure}}</p>\n                  <p class=\"station\">Estación central</p>\n                  <i class=\"fa fa-arrow-right\" aria-hidden=\"true\"></i>\n                </div>\n                <div class=\"col-sm-4 col-xs-6 xs-mar-20\">\n                  <p class=\"time\">{{tickets.newTicket.selectedReturnTrip.schedule.arrivalTime}}</p>\n                  <p class=\"date\">{{tickets.newTicket.selectedReturnTrip.date}}</p>\n                  <p class=\"city\">{{tickets.newTicket.returnRoute.destiny}}</p>\n                  <p class=\"station\">Estación central</p>\n                </div>\n                <div class=\"col-sm-4 wrapper-price\">\n                  <span class=\"price\">${{tickets.newTicket.selectedReturnTrip.schedule.routeRate.countryRates.CR}}</span><span class=\"gray-title\"> / por persona</span>\n                  <img src=\"assets/images/icon_features.jpg\" alt=\"Servicios\" class=\"img-responsive features-icons\" />\n                </div>\n              </div>--><div class=\"row route\" ng-if=!tickets.newTicket.returnRoute.transfer><div class=\"col-sm-4 col-xs-6 xs-mar-20 from\"><p class=time ng-show=\"tickets.newticket.typeOfTrip != 3\">{{tickets.newTicket.selectedReturnTrip.schedule.departureTime}}</p><p class=time ng-show=\"tickets.newticket.typeOfTrip == 3\">Hora abierta</p><p class=date ng-show=\"tickets.newticket.typeOfTrip != 3\">{{tickets.newTicket.selectedReturnTrip.date}}</p><p class=date ng-show=\"tickets.newticket.typeOfTrip == 3\">Fecha abierta</p><p class=city>{{tickets.newTicket.returnRoute.departure}}</p><p class=station>Estación central</p><i class=\"fa fa-arrow-right\" aria-hidden=true></i></div><div class=\"col-sm-4 col-xs-6 xs-mar-20\"><p class=time ng-show=\"tickets.newticket.typeOfTrip != 3\">{{tickets.newTicket.selectedReturnTrip.schedule.arrivalTime}}</p><p class=time ng-show=\"tickets.newticket.typeOfTrip == 3\">Hora abierta</p><p class=date ng-show=\"tickets.newticket.typeOfTrip != 3\">{{tickets.newTicket.selectedReturnTrip.date}}</p><p class=date ng-show=\"tickets.newticket.typeOfTrip == 3\">Fecha abierta</p><p class=city>{{tickets.newTicket.returnRoute.destiny}}</p><p class=station>Estación central</p></div><div class=\"col-sm-4 wrapper-price\"><span class=price ng-show=\"tickets.newticket.typeOfTrip != 3\"><span ng-if=!tickets.newTicket.returnRoute.transfer>${{tickets.newTicket.selectedReturnTrip.schedule.routeRate.countryRates.CR}}</span> </span><span class=price id=PriceOpen name=PriceOpen ng-show=\"tickets.newticket.typeOfTrip == 3\">${{tickets.openRouteRateT.countryRates.CR}}</span> <span class=gray-title>/ por persona</span> <img src=assets/images/icon_features.jpg alt=Servicios class=\"img-responsive features-icons\"></div></div><div class=\"row route\" ng-if=tickets.newTicket.returnRoute.transfer><div class=\"col-sm-4 col-xs-6 xs-mar-20 from\"><p class=time ng-show=\"tickets.newticket.typeOfTrip != 3\">{{tickets.newTicket.selectedReturnTrip.schedule.departureTime}}</p><p class=time ng-show=\"tickets.newticket.typeOfTrip == 3\">Hora abierta</p><p class=date ng-show=\"tickets.newticket.typeOfTrip != 3\">{{tickets.newTicket.selectedReturnTrip.date}}</p><p class=date ng-show=\"tickets.newticket.typeOfTrip == 3\">Fecha abierta</p><p class=city>{{tickets.newTicket.returnRoute.subRoutes[0].departure}}</p><p class=station>Estación central</p><i class=\"fa fa-arrow-right\" aria-hidden=true></i></div><div class=\"col-sm-4 col-xs-6 xs-mar-20\"><p class=time ng-show=\"tickets.newticket.typeOfTrip != 3\">{{tickets.newTicket.selectedReturnTrip.schedule.arrivalTime}}</p><p class=time ng-show=\"tickets.newticket.typeOfTrip == 3\">Hora abierta</p><p class=date ng-show=\"tickets.newticket.typeOfTrip != 3\">{{tickets.newTicket.selectedReturnTrip.date}}</p><p class=date ng-show=\"tickets.newticket.typeOfTrip == 3\">Fecha abierta</p><p class=city>{{tickets.newTicket.returnRoute.subRoutes[0].destiny}}</p><p class=station>Estación central</p></div><div class=\"col-sm-4 wrapper-price\" ng-show=\"tickets.newticket.typeOfTrip == 3\"><span class=price id=PriceOpen name=PriceOpen>${{tickets.openRouteRateT.countryRates.CR}}</span> <span class=gray-title>/ por persona</span> <img src=assets/images/icon_features.jpg alt=Servicios class=\"img-responsive features-icons\"></div></div><div class=\"row route\" ng-if=tickets.newTicket.returnRoute.transfer><div class=\"col-sm-4 col-xs-6 xs-mar-20 from\"><p class=time ng-show=\"tickets.newticket.typeOfTrip != 3\">{{tickets.newTicket.selectedTripT.schedule.departureTime}}</p><p class=time ng-show=\"tickets.newticket.typeOfTrip == 3\">Hora abierta</p><p class=date ng-show=\"tickets.newticket.typeOfTrip != 3\">{{tickets.newTicket.selectedTripT.date}}</p><p class=date ng-show=\"tickets.newticket.typeOfTrip == 3\">Fecha abierta</p><p class=city>{{tickets.newTicket.returnRoute.subRoutes[1].departure}}</p><p class=station>Estación central</p><i class=\"fa fa-arrow-right\" aria-hidden=true></i></div><div class=\"col-sm-4 col-xs-6 xs-mar-20\"><p class=time ng-show=\"tickets.newticket.typeOfTrip != 3\">{{tickets.newTicket.selectedTripT.schedule.arrivalTime}}</p><p class=time ng-show=\"tickets.newticket.typeOfTrip == 3\">Hora abierta</p><p class=date ng-show=\"tickets.newticket.typeOfTrip != 3\">{{tickets.newTicket.selectedTripT.date}}</p><p class=date ng-show=\"tickets.newticket.typeOfTrip == 3\">Fecha abierta</p><p class=city>{{tickets.newTicket.returnRoute.subRoutes[1].destiny}}</p><p class=station>Estación central</p></div><div class=\"col-sm-4 wrapper-price\"><span class=price ng-show=\"tickets.newticket.typeOfTrip != 3\"><span ng-if=tickets.newTicket.returnRoute.transfer>${{tickets.newTicket.returnPriceWithTransfer}}</span> </span><span class=price id=PriceOpen name=PriceOpen ng-show=\"tickets.newticket.typeOfTrip == 3\">${{tickets.openRouteRateT.countryRates.CR}}</span> <span class=gray-title>/ por persona</span> <img src=assets/images/icon_features.jpg alt=Servicios class=\"img-responsive features-icons\"></div></div></div></div></div></div><div class=\"row text-center\"><div class=\"col-xs-12 text-center\"><input type=button wz-next class=\"btn btn-primary btn-large\" value=Continuar></div></div></wz-step><wz-step wz-title=Pasajeros><div class=\"row wrapperSearchPassenger\"><p class=\"col-sm-12 p-top-20 m-bottom-30 font-16 bold\">Digite su número de pasaporte y la opción Buscar, si ya es cliente nuestro, su nombre aparecerá más abajo, si no lo es, elija agregar pasajero e ingrese sus datos</p><div class=\"col-sm-offset-3 col-sm-6 m-bottom-30\"><form class=\"form-inline text-right\" name=searchPassengerForm id=searchPassengerForm ng-submit=tickets.searchClient(tickets.identificationToSearch) novalidate><div class=input-group><input type=text class=form-control placeholder=\"Ingrese el número de identificación\" ng-model=tickets.identificationToSearch> <span class=input-group-btn><button class=\"btn btn-primary\" type=submit>Buscar</button></span></div></form></div></div><form id=passengerForm name=passengerForm ng-submit=tickets.submitPassenger(passengerForm) novalidate><div class=\"row passengers\"><div class=col-xs-12><uib-accordion close-others=false><uib-accordion-group is-open=tickets.isPassengerFormOpen><uib-accordion-heading><span ng-show=!tickets.isEditingPassenger>Agregar Nuevo Pasajero</span> <span ng-show=tickets.isEditingPassenger>Editando Pasajero</span> <i class=\"pull-left glyphicon m-right-10\" ng-class=\"{\'glyphicon-chevron-down\': tickets.isPassengerFormOpen, \'glyphicon-chevron-right\': !tickets.isPassengerFormOpen}\"></i></uib-accordion-heading><div class=row><div class=col-sm-3><div class=form-group><label for=FirstName>1er Nombre</label><input type=text name=FirstName id=FirstName class=form-control ng-model=tickets.passenger.firstName required><div class=error ng-messages=passengerForm.FirstName.$error ng-show=tickets.submitPassengerAttempt><p ng-message=required>El 1er Nombre es requerido</p></div></div></div><div class=col-sm-3><div class=form-group><label for=FirstName>2do Nombre</label><input type=text name=MiddleName id=MiddleName class=form-control ng-model=tickets.passenger.middleName></div></div><div class=col-sm-3><div class=form-group><label for=LastName>1er Apellido</label><input type=text name=LastName id=LastName class=form-control ng-model=tickets.passenger.lastName required><div class=error ng-messages=passengerForm.LastName.$error ng-show=tickets.submitPassengerAttempt><p ng-message=required>El 1er Apellido es requerido</p></div></div></div><div class=col-sm-3><div class=form-group><label for=LastName2>2do Apellido</label><input type=text name=LastName2 id=LastName2 class=form-control ng-model=tickets.passenger.lastName2></div></div></div><div class=row><div class=col-sm-3><div class=form-group><label for=ClientIdentification>Número de pasaporte</label><input type=text name=ClientIdentification id=ClientIdentification class=form-control ng-model=tickets.passenger.identification required ng-disabled=tickets.isEditingPassenger><div class=error ng-messages=passengerForm.ClientIdentification.$error ng-show=tickets.submitPassengerAttempt><p ng-message=required>La Identificación es requerida</p></div></div></div><div class=col-sm-3><div class=form-group><label for=IdentificationExpiration>Vencimiento</label><p class=input-group><input type=text name=IdentificationExpiration id=IdentificationExpiration class=form-control uib-datepicker-popup=\"{{\'dd/MM/yyyy\'}}\" ng-model=tickets.passenger.identificationExpirationUI is-open=tickets.showIECalendar alt-input-formats=\"[\'DD/MM/YYYY\']\" required> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=tickets.openIECalendar()><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p><div class=error ng-show=tickets.submitPassengerAttempt><p ng-show=passengerForm.IdentificationExpiration.$error.required>El Vencimiento de Identificación es requerido</p><p ng-show=passengerForm.IdentificationExpiration.$error.date>Fecha Invalida</p></div></div></div><div class=col-sm-3><div class=form-group><label for=birthdate>Fecha de Nacimiento</label><p class=input-group><input type=text name=birthdate id=birthdate class=form-control uib-datepicker-popup=\"{{\'dd/MM/yyyy\'}}\" ng-model=tickets.passenger.birthdateUI is-open=tickets.showBDCalendar alt-input-formats=\"[\'DD/MM/YYYY\']\" required> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=tickets.openBDCalendar()><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p><div class=error ng-show=tickets.submitPassengerAttempt><p ng-show=passengerForm.birthdate.$error.required>El Vencimiento de Identificación es requerido</p><p ng-show=passengerForm.birthdate.$error.date>Fecha Invalida</p></div></div></div><div class=col-sm-3><div class=form-group><label for=Profession>Profesión</label><input type=text name=Profession id=Profession class=form-control ng-model=tickets.passenger.profession required><div class=error ng-messages=passengerForm.Profession.$error ng-show=tickets.submitPassengerAttempt><p ng-message=required>La Profesión es requerida</p></div></div></div></div><div class=row><div class=col-sm-3><div class=form-group><div class=form-group><label>Nacionalidad</label><select name=Nationality id=Nationality class=form-control ng-model=tickets.passenger.nationality required ng-options=\"na.name as na.name for na in tickets.nationalities\"><option value=\"\">Nacionalidad</option></select><div class=error ng-messages=passengerForm.Nationality.$error ng-show=tickets.submitPassengerAttempt><p ng-message=required>La Nacionalidad es requerida</p></div></div></div></div><div class=col-sm-3><div class=form-group><div class=form-group><label>Estatus Migratorio</label><select name=MigratoryStatus id=MigratoryStatus class=form-control ng-model=tickets.passenger.migratoryStatus><option value=\"\">Estatus Migratorio</option><option value=\"No residente\">No residente</option><option value=Residente>Residente</option><option value=Turista>Turista</option></select></div></div></div><div class=col-sm-3><div class=form-group><label>Teléfono / Móvil</label><input type=text name=Phone id=Phone class=form-control ng-model=tickets.passenger.phone required><div class=error ng-messages=passengerForm.Phone.$error ng-show=tickets.submitPassengerAttempt><p ng-message=required>El Teléfono es requerido</p></div></div></div><div class=col-sm-3><div class=form-group><label for=Email>Email</label><input type=email name=Email id=Email class=form-control ng-model=tickets.passenger.email required><div class=error ng-messages=passengerForm.Email.$error ng-show=tickets.submitPassengerAttempt><p ng-message=required>El correo electrónico es requerido</p><p ng-message=email>Correo electrónico invalido</p></div></div></div><div class=col-sm-3></div></div><div class=row><div class=col-sm-3><div class=form-group><label>Genero</label><div><div class=\"radio radio-inline\" ng-repeat=\"genre in tickets.genres\"><input type=radio name=genre id=genre{{$index}} ng-value=genre.id ng-model=tickets.passenger.genre required><label for=genre{{$index}}>{{genre.name}}</label></div></div><div class=error ng-messages=passengerForm.genre.$error ng-show=tickets.submitPassengerAttempt><p ng-message=required>El Genero es requerido</p></div></div></div><div class=col-sm-3><div class=form-group><label for=civilStatus>Estado Civil</label><select name=civilStatus id=civilStatus class=form-control ng-options=\"cs.name as cs.name for cs in tickets.civilStatues\" ng-model=tickets.passenger.civilStatus required><option value=\"\">Estado Civil</option></select><div class=error ng-messages=passengerForm.civilStatus.$error ng-show=tickets.submitPassengerAttempt><p ng-message=required>El estado civil es requerido</p></div></div></div><div class=col-sm-6><div class=form-group><label for=Address>Dirección de destino</label><textarea class=form-control name=Address id=Address cols=30 rows=5 ng-model=tickets.passenger.address required></textarea><div class=error ng-messages=passengerForm.Address.$error ng-show=tickets.submitPassengerAttempt><p ng-message=required>La dirección es requerida</p></div></div></div></div><div class=\"row buttons-wrapper\"><div class=\"col-sm-12 text-right\"><button type=button class=\"btn btn-default btn-large\" ng-click=tickets.closePassengerForm()>Cancelar</button> <button type=submit class=\"btn btn-primary btn-large\">Agregar</button></div></div></uib-accordion-group></uib-accordion></div></div></form><div class=table-responsive ng-show=\"tickets.newticket.clients.length > 0\"><table class=\"table table-bordered table-hover passengers-list\"><thead><tr><th>Identicación</th><th>Nombre</th><th>Abordajes</th><th></th></tr></thead><tbody><tr ng-repeat=\"client in tickets.newticket.clients\"><td name=Identification{{$index}} id=Identification{{$index}}>{{client.identification}}</td><td name=passengerName{{$index}} id=passengerName{{$index}}>{{client.fullName}}</td><td><div class=container-fluid><div class=row><div class=col-xs-6><div class=form-group><label for=boarding>Abordaje Ida</label><select name=boarding id=boarding class=\"form-control boarding-selects\" ng-options=\"boarding as boarding.name for boarding in tickets.boardingList\" ng-model=client.boarding><option value=\"\">Abordaje</option></select></div></div><div class=col-xs-6><div class=form-group ng-show=tickets.newTicket.returnRoute><label for=boarding>Abordaje Vuelta</label><select name=boarding id=boarding class=\"form-control boarding-selects\" ng-options=\"boarding as boarding.name for boarding in tickets.returnBoardingList\" ng-model=client.returnBoarding ng-disabled=!tickets.newTicket.returnRoute><option value=\"\">Abordaje</option></select></div></div></div></div></td><td class=text-right><i class=\"fa fa-pencil tbl-action-btn m-right-10\" aria-hidden=true ng-show=client.isNew ng-click=tickets.editClient(client)></i> <i class=\"fa fa-times tbl-action-btn\" aria-hidden=true ng-click=tickets.removeClient($index) ng-disabled=tickets.isEditingPassenger></i></td></tr></tbody></table></div><div class=row><div class=\"col-sm-12 checkbox-link-label\" ng-show=\"tickets.newticket.clients.length > 0\"><input type=checkbox ng-model=tickets.isRegulationsAccepted>Acepto las <a href ng-click=tickets.showMigrationRegulations()>normativas migratorias</a></div><div class=\"col-sm-12 m-top-10 text-center\"><button type=submit class=\"btn btn-primary btn-large\" ng-click=tickets.chooseSeats() ng-disabled=!tickets.isRegulationsAccepted ng-show=\"tickets.newticket.typeOfTrip != 3 && tickets.newticket.clients.length > 0\">Elegir Asientos</button> <button type=submit class=\"btn btn-primary btn-large\" ng-show=\"tickets.newticket.typeOfTrip == 3 && tickets.newticket.clients.length > 0\" ng-disabled=!tickets.isRegulationsAccepted ng-click=tickets.calcTotalAndNext()>Continuar</button></div></div></wz-step><wz-step wz-title=Pago><form id=TicketStep4Form name=TicketStep4Form ng-submit=tickets.payTickets(TicketStep4Form) novalidate><div class=\"row m-top-20\"><div class=col-xs-12><div class=row><div class=col-xs-12><p class=payment-timer>Le recordamos que tiene 5 minutos para realizar su pago</p><div class=\"panel panel-default\"><div class=panel-heading><h4 class=panel-title>Resumen de Itinerario</h4></div><div class=\"panel-body summary\"><div class=row><div class=col-xs-6><div class=row><div class=col-xs-4><strong>Ruta:</strong></div><div class=col-xs-8><p ng-if=!tickets.newTicket.route.transfer class=muted>{{tickets.newTicket.route.name}}</p><p ng-if=tickets.newTicket.route.transfer class=muted>{{tickets.newTicket.route.subRoutes[0].name}}</p></div></div><div class=row><div class=col-xs-4><strong>Fecha:</strong></div><div class=col-xs-8><span ng-show=tickets.newTicket.selectedTrip.date>{{tickets.newTicket.selectedTrip.date | amDateFormat: dateFormat}}</span> <span ng-show=!tickets.newTicket.selectedTrip.date>--</span></div></div></div><div class=col-xs-6><div class=row><div class=col-xs-4><strong>Horario:</strong></div><div class=col-xs-8>{{tickets.newTicket.selectedTrip.schedule.departureTime || \'--\'}}</div></div><div class=row><div class=col-xs-4><strong>Tipo de Bus:</strong></div><div class=col-xs-8>{{tickets.newTicket.selectedTrip.schedule.routeRate.busClass.name || tickets.openRouteRate.busClass.name}}</div></div></div></div><div class=m-top-20 ng-if=tickets.newTicket.route.transfer><div class=row><div class=col-xs-6><div class=row><div class=col-xs-4><strong>Ruta:</strong></div><div class=col-xs-8><p class=muted>{{tickets.newTicket.route.subRoutes[1].name}}</p></div></div><div class=row><div class=col-xs-4><strong>Fecha:</strong></div><div class=col-xs-8><span ng-show=tickets.newTicket.selectedTripT.date>{{tickets.newTicket.selectedTripT.date | amDateFormat: dateFormat}}</span> <span ng-show=!tickets.newTicket.selectedTripT.date>--</span></div></div></div><div class=col-xs-6><div class=row><div class=col-xs-4><strong>Horario:</strong></div><div class=col-xs-8>{{tickets.newTicket.selectedTripT.schedule.departureTime || \'--\'}}</div></div><div class=row><div class=col-xs-4><strong>Tipo de Bus:</strong></div><div class=col-xs-8>{{tickets.newTicket.selectedTripT.schedule.routeRate.busClass.name || tickets.openRouteRate.busClass.name}}</div></div></div></div></div><div class=row ng-show=\"tickets.newticket.typeOfTrip == 2\"><div class=\"col-xs-12 col-md-6\"><div class=row><div class=col-xs-4><strong>Ruta:</strong></div><div class=col-xs-8><p ng-if=!tickets.newTicket.returnRoute.transfer class=muted>{{tickets.newTicket.returnRoute.name}}</p><p ng-if=tickets.newTicket.returnRoute.transfer class=muted>{{tickets.newTicket.returnRoute.subRoutes[0].name}}</p></div></div><div class=row><div class=col-xs-4><strong>Fecha:</strong></div><div class=col-xs-8><span ng-show=tickets.newTicket.selectedReturnTrip.date>{{tickets.newTicket.selectedReturnTrip.date | amDateFormat: dateFormat}}</span> <span ng-show=!tickets.newTicket.selectedReturnTrip.date>--</span></div></div></div><div class=\"col-xs-12 col-md-6\"><div class=row><div class=col-xs-4><strong>Horario:</strong></div><div class=col-xs-8>{{tickets.newTicket.selectedReturnTrip.schedule.departureTime || \'--\'}}</div></div><div class=row><div class=col-xs-4><strong>Tipo de Bus:</strong></div><div class=col-xs-8>{{tickets.newTicket.selectedReturnTrip.schedule.routeRate.busClass.name || tickets.openRouteRateT.busClass.name }}</div></div></div></div><div class=m-top-20 ng-if=tickets.newTicket.returnRoute.transfer><div class=row><div class=col-xs-6><div class=row><div class=col-xs-4><strong>Ruta:</strong></div><div class=col-xs-8><p class=muted>{{tickets.newTicket.returnRoute.subRoutes[1].name}}</p></div></div><div class=row><div class=col-xs-4><strong>Fecha:</strong></div><div class=col-xs-8><span ng-show=tickets.newTicket.selectedReturnTripT.date>{{tickets.newTicket.selectedReturnTripT.date | amDateFormat: dateFormat}}</span> <span ng-show=!tickets.newTicket.selectedReturnTripT.date>--</span></div></div></div><div class=col-xs-6><div class=row><div class=col-xs-4><strong>Horario:</strong></div><div class=col-xs-8>{{tickets.newTicket.selectedReturnTripT.schedule.departureTime || \'--\'}}</div></div><div class=row><div class=col-xs-4><strong>Tipo de Bus:</strong></div><div class=col-xs-8>{{tickets.newTicket.selectedReturnTripT.schedule.routeRate.busClass.name || tickets.openRouteRateT.busClass.name}}</div></div></div></div></div></div></div></div></div></div><div class=col-xs-12><div class=row><div class=col-xs-12><div class=\"panel panel-default\"><div class=panel-heading><h4 class=panel-title>Pasajeros</h4></div><div class=\"panel-body table-responsive\"><table class=\"table table-striped\"><thead><tr><th>Identificación</th><th>Cliente</th><th>Ruta</th><th>Abordaje</th><th>Asiento</th><th>Precio</th></tr></thead><tbody><tr ng-repeat=\"client in tickets.newticket.clients\"><td>{{client.identification}}</td><td>{{client.fullName}}</td><td>{{tickets.newTicket.route.name}} <span ng-if=tickets.newTicket.route.transfer>/ {{tickets.newTicket.route.subRoutes[0].name}}</span></td><td>{{client.boarding.name || \'Terminal\'}}</td><td>{{tickets.selectedSeat[$index].seatNumber || \'--\'}}</td><td><div ng-if=!tickets.newTicket.route.transfer><span ng-show=tickets.newTicket.selectedTrip.schedule.routeRate>${{ client.hasDiscount ? tickets.newTicket.selectedTrip.schedule.routeRate.countryRates.CR - ((tickets.newTicket.selectedTrip.schedule.routeRate.countryRates.CR / 100) * tickets.discountToApply) : tickets.newTicket.selectedTrip.schedule.routeRate.countryRates.CR }} </span><span ng-show=tickets.openRouteRate>${{ client.hasDiscount ? tickets.openRouteRate.countryRates.CR - ((tickets.openRouteRate.countryRates.CR / 100) * tickets.discountToApply) : tickets.openRouteRate.countryRates.CR }}</span></div><div ng-if=tickets.newTicket.route.transfer>${{tickets.newTicket.priceWithTransfer}}</div></td></tr><tr ng-repeat=\"client in tickets.newticket.clients\" ng-if=tickets.newTicket.route.transfer><td>{{client.identification}}</td><td>{{client.fullName}}</td><td>{{tickets.newTicket.route.subRoutes[1].name}}</td><td>--</td><td>{{tickets.selectedSeatT[$index].seatNumber || \'--\'}}</td><td>--</td></tr><tr ng-repeat=\"client in tickets.newticket.clients\" ng-if=\"tickets.newticket.typeOfTrip == 2\"><td>{{client.identification}}</td><td>{{client.fullName}}</td><td>{{tickets.newTicket.returnRoute.name}} <span ng-if=tickets.newTicket.returnRoute.transfer>/ {{tickets.newTicket.returnRoute.subRoutes[0].name}}</span></td><td>{{client.returnBoarding.name || \'Terminal\'}}</td><td>{{tickets.selectedReturnSeat[$index].seatNumber}}</td><td><div ng-if=!tickets.newTicket.returnRoute.transfer><span ng-show=tickets.newTicket.selectedReturnTrip.schedule.routeRate>${{ client.hasDiscount ? tickets.newTicket.selectedReturnTrip.schedule.routeRate.countryRates.CR - ((tickets.newTicket.selectedReturnTrip.schedule.routeRate.countryRates.CR / 100) * tickets.discountToApply) : tickets.newTicket.selectedReturnTrip.schedule.routeRate.countryRates.CR }} </span><span ng-show=tickets.openRouteRate>${{ client.hasDiscount ? tickets.openRouteRateT.countryRates.CR - ((tickets.openRouteRateT.countryRates.CR / 100) * tickets.discountToApply) : tickets.openRouteRateT.countryRates.CR }}</span></div><div ng-if=tickets.newTicket.returnRoute.transfer>${{tickets.newTicket.returnPriceWithTransfer}}</div></td></tr><tr ng-repeat=\"client in tickets.newticket.clients\" ng-if=\"tickets.newTicket.returnRoute.transfer && tickets.newticket.typeOfTrip == 2\"><td>{{client.identification}}</td><td>{{client.fullName}}</td><td>{{tickets.newTicket.returnRoute.subRoutes[1].name}}</td><td>--</td><td>{{tickets.selectedReturnSeatT[$index].seatNumber || \'--\'}}</td><td>--</td></tr><tr class=hidden-xs><td colspan=5><strong>TOTAL:</strong></td><td>${{tickets.newTicket.total}}</td></tr><tr class=visible-xs-block><td><strong>TOTAL:</strong></td><td colspan=4 class=text-left>${{tickets.newTicket.total}}</td></tr></tbody></table></div></div></div></div></div><fieldset ng-disabled=tickets.paymentInProgress class=col-xs-12><div class=\"row creditCardInfo\"><div class=col-xs-12><div class=\"panel panel-default\"><div class=panel-heading><h4 class=panel-title>Información de su tarjeta <span ng-if=tickets.paymentErrors class=error><strong>Hubo un error realizando el pago, verifique la información Ingresada</strong></span></h4></div><div class=panel-body><div class=row ng-if=tickets.paymentErrors><div class=col-xs-12><p class=error>{{tickets.paymentErrors}}</p></div></div><div class=row><div class=col-sm-6><div class=form-group><label for=CreditCardNumber>Número de tarjeta</label><input type=text name=CreditCardNumber id=CreditCardNumber class=\"form-control cc-type\" ng-model=tickets.creditCard.number ng-class=\"\'cc-type-\'+ TicketStep4Form.CreditCardNumber.$ccEagerType\" cc-number cc-eager-type required maxlength=19><div class=error ng-messages=TicketStep4Form.CreditCardNumber.$error ng-show=tickets.submitAttemptStep4><p ng-message=required>El número de tarjeta es requerido</p><p ng-message=ccNumber>Tarjeta Invalida</p></div></div></div><div class=col-sm-6><div class=form-group><label for=CreditCardName>Nombre en la tarjeta</label><input type=text name=CreditCardName id=CreditCardName class=form-control ng-model=tickets.creditCard.nombre required><div class=error ng-messages=TicketStep4Form.CreditCardName.$error ng-show=tickets.submitAttemptStep4><p ng-message=required>El nombre en la tarjeta es requerido</p></div></div></div></div><div class=row><div class=col-sm-4><div class=form-group><label for=CreditCardExpirationMonth>Expiración</label><select name=CreditCardExpirationMonth id=CreditCardExpirationMonth class=form-control ng-model=tickets.creditCard.expiration.month required ng-options=\"month as month for month in tickets.months\"><option value=\"\">Mes</option></select><div class=error ng-messages=TicketStep4Form.CreditCardExpirationMonth.$error ng-show=tickets.submitAttemptStep4><p ng-message=required>El mes de expiración es requerido</p></div></div></div><div class=col-sm-4><div class=form-group><label for=CreditCardExpirationYear>i</label><select name=CreditCardExpirationYear id=CreditCardExpirationYear class=form-control ng-model=tickets.creditCard.expiration.year required ng-options=\"year.value as year.desc for year in tickets.years\"><option value=\"\">Año</option></select><div class=error ng-messages=TicketStep4Form.CreditCardExpirationYear.$error ng-show=tickets.submitAttemptStep4><p ng-message=required>El año de expiración es requerido</p></div></div></div><div class=col-sm-4><div class=form-group><label for=CreditCardCvv>CVV <small>(Número que aparece detrás de la tarjeta)</small></label><input type=text name=CreditCardCvv id=CreditCardCvv class=form-control maxlength=4 ng-model=tickets.creditCard.cvv required><div class=error ng-messages=TicketStep4Form.CreditCardCvv.$error ng-show=tickets.submitAttemptStep4><p ng-message=required>El CVV es requerido</p></div></div></div></div></div></div></div></div><div class=\"col-sm-12 checkbox-link-label\"><input ng-disabled=tickets.paymentInProgress type=checkbox ng-model=tickets.isTermsAccepted>Acepto los<a href ng-click=tickets.showTermsAndConditions()> términos y condiciones</a></div><div class=\"m-top-10 text-center\"><button type=button class=\"btn btn-default\" ng-disabled=tickets.paymentInProgress ng-click=tickets.cancelReservation()>Cancelar Compra</button> <button type=submit class=\"btn btn-secondary\" ng-disabled=\"tickets.paymentInProgress || tickets.ticketsPaid || !tickets.isTermsAccepted\" ladda=tickets.loading>Comprar Boletos</button></div></fieldset></div></form></wz-step></wizard></div><tnsp-modal-regulations></tnsp-modal-regulations><tnsp-modal-terms></tnsp-modal-terms><tnsp-modal-terms-and-conditions></tnsp-modal-terms-and-conditions><tnsp-modal-seats-form tickets=tickets></tnsp-modal-seats-form><tnsp-modal-client-form client=tickets.selectedClient></tnsp-modal-client-form><tnsp-modal-print-ticket-invoice invoices-ids=tickets.invoices show-preview=true transaction-number=tickets.invoiceNumber></tnsp-modal-print-ticket-invoice>");
$templateCache.put("app/components/modal-regulations/modal-regulations.html","<div class=\"modal fade\" id=modalRegulations tabindex=-1 role=dialog aria-labelledby=modalRegulations><div class=\"modal-dialog modal-lg\" role=document><div class=modal-content><div class=modal-header><button type=button class=close data-dismiss=modal aria-label=Close><span aria-hidden=true>&times;</span></button><h4 class=modal-title>Normativas Migratorias</h4></div><div class=modal-body><ol><li>Todo pasajero debe viajar con sus documentos migratorios al día y en orden, según la regulación Migratoria del país de destino.</li><li>La empresa no tendrá responsabilidad con aquellos pasajeros que sufran atrasos en puestos migratorios ni de aduanas por aforo de su carga o trámites migratorios, por respeto a los demás pasajeros, el conductor no puede esperar a pasajeros.</li><li>Cada pasajero debe estar pendiente del trámite de su equipaje en frontera y tiene la obligación de velar por sus pertenencias en la Aduana, la empresa no responde por pérdidas en esta zona.</li><li>El pasajero declara bajo juramento o promesa, la veracidad de la información consignada y que la información sobre sus documentos ingresada a ventastransnica.com es copia fiel del original. En el caso de no ser cierta la manifestación antes señalada, el pasajero asume las consecuencias legales ante Migración y/o autoridades de cada país que pudieran derivarse de su actuación. La empresa Transnica, conforme a la normativa vigente, no realizará reembolsos, no se responsabilizará por retrasos o suspensiones, ni reconocerá validez alguna de la información del pasajero, a los efectos para los que ha sido presentada.</li></ol></div><div class=modal-footer><button type=button class=\"btn btn-primary\" data-dismiss=modal>Aceptar</button></div></div><!-- /.modal-content --></div></div>");}]);